<template>
    <v-layout>
        <v-flex xs12>
            <v-card class="elevation-0">
                <v-card-title 
                    class="accent white--text title" 
                    style="width:100%; position:fixed; top: 0; left:0; z-index: 3;">
                    {{'Chart Builder'|translate}}
                </v-card-title>
                <v-card-text  
                    style="margin-top:30px;margin-bottom:50px;">
                    <v-layout row v-if="loading">
                        <v-flex xs12>
                            <v-progress-linear :indeterminate="true"></v-progress-linear>
                        </v-flex>
                    </v-layout>
                    <v-layout row v-if="!loading">
                        <v-flex :class="[headlessMode ? 'xs12' : 'xs9']">
                            <v-layout row>
                                <v-flex xs3 v-show="showPointsTree">
                                    <div class="mr-1">
                                        <v-card  style="position: fixed; overflow-y: auto; overflow-x: auto; max-height: 90%;">
                                            <v-card-text>
                                                <points-draggable chart-mode :chart-layout="lastLayoutOverrides"></points-draggable>
                                            </v-card-text>
                                        </v-card>
                                    </div>

                                </v-flex>
                                <v-flex :class="[showPointsTree ? 'xs9' : 'xs12']">
                                    <v-layout row wrap>
                                        <v-flex xs1>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }" >
                                                    <v-icon
                                                        class="ml-3 mt-4"
                                                        :color="showPointsTree ? 'success' : null"
                                                        small
                                                        v-on="on"
                                                        @click="showPointsTree=!showPointsTree"
                                                    >
                                                        fa-sitemap
                                                    </v-icon>
                                                </template>
                                                <span>{{'Toggle sensor picker'|translate}}</span>
                                            </v-tooltip>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }" >
                                                    <v-icon
                                                        class="ml-3 mt-4"
                                                        :color="debugMode ? 'success' : null"
                                                        small
                                                        v-on="on"
                                                        @click="debugMode=!debugMode; applySettings();"
                                                    >
                                                        fa-bug
                                                    </v-icon>
                                                </template>
                                                <span>{{'Toggle debug mode'|translate}}</span>
                                            </v-tooltip>
                                            <v-tooltip bottom>
                                                <template v-slot:activator="{ on }" >
                                                    <v-icon
                                                        class="ml-3 mt-4"
                                                        :color="showCentralizedAgg ? 'success' : null"
                                                        small
                                                        v-on="on"
                                                        @click="showCentralizedAgg=!showCentralizedAgg;"
                                                    >
                                                        fa-clock
                                                    </v-icon>
                                                </template>
                                                <span>{{'Time aggregation'|translate}}</span>
                                            </v-tooltip>
                                        </v-flex>
                                        <v-flex xs4>
                                            <date-range-selector v-model="range"></date-range-selector>
                                        </v-flex>
                                        <v-flex xs7>
                                            <v-layout row>
                                                <v-spacer></v-spacer>
                                                <v-btn color="primary" @click="applySettings">{{'Refresh'|translate}}</v-btn>
                                                <v-btn color="primary" @click="addQuery">{{'Add Query'|translate}}</v-btn>
                                                <v-btn color="primary" @click="copyToCP">{{'Export'|translate}}</v-btn>
                                                <v-btn color="primary" @click="addJsonDialog=true">{{'Import'|translate}}</v-btn>
                                                <v-dialog v-model="addJsonDialog" max-width="800" persistent>
                                                    <v-card v-if="addJsonDialog">
                                                        <v-card-title class="primary white--text title">
                                                            {{'Import query from JSON'|translate}}
                                                        </v-card-title>
                                                        <editor v-model="jsonImport" @init="jsonEditorInit" lang="json" theme="twilight" width="100%" height="500"></editor>
                                                        <v-card-actions>
                                                            <v-spacer></v-spacer>
                                                            <v-btn class="primary" :disabled="!jsonImport||jsonImport===''" @click="importFromJson">{{'Import'|translate}}</v-btn>
                                                            <v-btn @click="jsonImport=''; addJsonDialog=false">{{'Cancel'|translate}}</v-btn>
                                                        </v-card-actions>
                                                    </v-card>
                                                </v-dialog>
                                            </v-layout>
                                        </v-flex>
                                        <v-flex xs12 v-if="showCentralizedAgg">
                                            <v-card class="mb-1">
                                                <v-card-text>
                                            <v-layout row wrap>
                                                <v-flex xs2 class="pa-2">
                                                    <h4 class="pt-4">{{'Time Aggregation'|translate}}</h4>
                                                </v-flex>
                                                <v-flex xs2 class="pa-2">
                                                    <v-select
                                                        :items="aggFreq"
                                                        :label="'Frequency'|translate"
                                                        v-model="centralizedAgg.agg"
                                                    ></v-select>
                                                </v-flex>
                                                <v-flex xs2 class="pa-2">
                                                    <v-select
                                                        :items="aggOpp"
                                                        :label="'Operation'|translate"
                                                        v-model="centralizedAgg.agg_op"
                                                    ></v-select>
                                                </v-flex>
                                                <v-flex xs6 class="pa-2">

                                                    <v-layout row>
                                                        <v-switch color="success" v-if="centralizedAgg.agg_op==='sum'"
                                                                  v-model="centralizedAgg.divide_by_sf"
                                                                  :label="'Divide by sampling freq'|translate"
                                                        ></v-switch>
                                                        <v-spacer></v-spacer>
                                                        <v-btn color="primary" @click="applyCentralizedAgg">{{'Apply'|translate}}</v-btn>
                                                        <v-btn color="primary" @click="clearCentralizedAgg">{{'Clear'|translate}}</v-btn>

                                                    </v-layout>

                                                </v-flex>


                                            </v-layout>
                                                </v-card-text>
                                            </v-card>
                                        </v-flex>
                                        <v-flex xs12 style="min-height: 372px">
                                            <data3-chart ref="plots"
                                                         @plotclick="handleChartClick"
                                                         :layout-overrides="chartConfig['layout-overrides']"
                                                         :x-axis="chartConfig['x-axis']"
                                                         :y-axis="chartConfig['y-axis']"
                                                         :color-axis="chartConfig['color-axis']"
                                                         :marker-size-axis="chartConfig['marker-size-axis']"
                                                         :color-axis-scale="chartConfig['color-axis-scale']"
                                                         :color-axis-title="chartConfig['color-axis-title']"
                                                         :independent-x="chartConfig['independent-x']"
                                                         :parameters="parameters"
                                                         disable-responsive
                                                         show-units
                                                         show-errors
                                                         :data-payload="chartConfig['data-payload']"
                                                         :series-overrides="chartConfig['series-overrides']"
                                                         :date-range="range"></data3-chart>
                                        </v-flex>
                                        <v-flex xs12>
                                            <draggable v-model="editChartConfig['data-payload']" :group="{ name: 'a', pull: false}" @add="applySettings" style="min-height:200px;">
                                                <div v-for="(payload,payloadIndex) in editChartConfig['data-payload']" style="margin-top:20px; margin-bottom: 20px;">
                                                    <v-card>
                                                        <v-card-title class="accent white--text subheading">
                                                            {{'Query'|translate}} {{payloadIndex+1}}
                                                            <v-tooltip bottom v-if="!payload.hideInBuilder">
                                                                <template v-slot:activator="{ on }" >
                                                                    <v-icon
                                                                        class="ml-2"
                                                                        small
                                                                        v-on="on"
                                                                        @click="$set(payload,'hideInBuilder',true)"
                                                                    >
                                                                        fa-chevron-up
                                                                    </v-icon>
                                                                </template>
                                                                <span>{{'Collapse'|translate}}</span>
                                                            </v-tooltip>
                                                            <v-tooltip bottom v-if="payload.hideInBuilder">
                                                                <template v-slot:activator="{ on }" >
                                                                    <v-icon
                                                                        class="ml-2"
                                                                        small
                                                                        v-on="on"
                                                                        @click="$set(payload,'hideInBuilder',false)"
                                                                    >
                                                                        fa-chevron-down
                                                                    </v-icon>
                                                                </template>
                                                                <span>{{'Expand'|translate}}</span>
                                                            </v-tooltip>
                                                            <v-spacer></v-spacer>
                                                            <div style="height: 24px; margin-right: 12px;"><v-switch color="success"
                                                                                                                     v-model="payload.latest_only"
                                                                                                                     :label="'Latest Only'|translate"
                                                            ></v-switch></div>
                                                            <div style="height: 24px; margin-right: 12px;"><v-switch color="success"
                                                                                                                     v-model="payload.onOnly"
                                                                                                                     :label="'On Only'|translate"
                                                            ></v-switch></div>
                                                            <div style="height: 24px; margin-right: 12px;" v-if="!payload.useCustomRange"><v-switch color="success"
                                                                                                                                                    v-model="payload.offsetRange"
                                                                                                                                                    :label="'Date range offset'|translate"
                                                            ></v-switch></div>
                                                            <div style="height: 24px; margin-right: 12px;"><v-switch color="success"
                                                                                                                     v-model="payload.useCustomRange"
                                                                                                                     :label="'Custom date range'|translate"
                                                            ></v-switch></div>
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on }" >
                                                                    <v-icon
                                                                        class="mr-2"
                                                                        small
                                                                        v-on="on"
                                                                        @click="addAgg(payloadIndex)"
                                                                    >
                                                                        fa-clock
                                                                    </v-icon>
                                                                </template>
                                                                <span>{{'Add Time Aggregation'|translate}}</span>
                                                            </v-tooltip>

                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on }" >
                                                                    <v-icon
                                                                        class="mr-2"
                                                                        small
                                                                        v-on="on"
                                                                        @click="addAggH(payloadIndex)"
                                                                    >
                                                                        fa-indent
                                                                    </v-icon>
                                                                </template>
                                                                <span>{{'Add Aggregation'|translate}}</span>
                                                            </v-tooltip>

                                                            <v-speed-dial
                                                                direction="top"
                                                            >
                                                                <template v-slot:activator>

                                                                    <v-icon class="mr-2" small>fa-plus</v-icon>


                                                                </template>
                                                                <v-tooltip left>
                                                                    <template v-slot:activator="{ on }" >
                                                                        <v-icon
                                                                            class="mb-3 secondary pa-1"
                                                                            small
                                                                            v-on="on"
                                                                            @click="addCalc(payloadIndex)"
                                                                        >
                                                                            fa-calculator
                                                                        </v-icon>
                                                                    </template>
                                                                    <span>{{'Add Series Calculation'|translate}}</span>
                                                                </v-tooltip>
                                                                <v-tooltip left>
                                                                    <template v-slot:activator="{ on }" >
                                                                        <v-icon
                                                                            class="mb-3 secondary pa-1"
                                                                            small
                                                                            v-on="on"
                                                                            @click="addCalcGlobal(payloadIndex)"
                                                                        >
                                                                            fa-table
                                                                        </v-icon>
                                                                    </template>
                                                                    <span>{{'Add Dataframe Transformation'|translate}}</span>
                                                                </v-tooltip>
                                                                <v-tooltip left>
                                                                    <template v-slot:activator="{ on }" >
                                                                        <v-icon
                                                                            class="mb-3 secondary pa-1"
                                                                            small
                                                                            v-on="on"
                                                                            @click="addNotes(payloadIndex)"
                                                                        >
                                                                            fa-comment
                                                                        </v-icon>
                                                                    </template>
                                                                    <span>{{'Add Notes'|translate}}</span>
                                                                </v-tooltip>
                                                                <v-tooltip left>
                                                                    <template v-slot:activator="{ on }" >
                                                                        <v-icon
                                                                            class="mb-3 secondary pa-1"
                                                                            small
                                                                            v-on="on"
                                                                            @click="addCovertToEnum(payloadIndex)"
                                                                        >
                                                                            fa-table
                                                                        </v-icon>
                                                                    </template>
                                                                    <span>{{'Add Conversion to enum'|translate}}</span>
                                                                </v-tooltip>
                                                                <v-tooltip left>
                                                                    <template v-slot:activator="{ on }" >
                                                                        <v-icon
                                                                            class="mb-3 secondary pa-1"
                                                                            small
                                                                            v-on="on"
                                                                            @click="addFilter(payloadIndex)"
                                                                        >
                                                                            fa-filter
                                                                        </v-icon>
                                                                    </template>
                                                                    <span>{{'Add Filter'|translate}}</span>
                                                                </v-tooltip>
                                                                <v-tooltip left>
                                                                    <template v-slot:activator="{ on }" >
                                                                        <v-icon
                                                                            class="mb-3 secondary pa-1"
                                                                            small
                                                                            v-on="on"
                                                                            @click="addSeriesSelect(payloadIndex)"
                                                                        >
                                                                            fa-columns
                                                                        </v-icon>
                                                                    </template>
                                                                    <span>{{'Add Series Selection'|translate}}</span>
                                                                </v-tooltip>
                                                                <v-tooltip left>
                                                                    <template v-slot:activator="{ on }" >
                                                                        <v-icon
                                                                            class="mb-3 secondary pa-1"
                                                                            small
                                                                            v-on="on"
                                                                            @click="addSeriesCalendar(payloadIndex)"
                                                                        >
                                                                            fa-calendar-plus
                                                                        </v-icon>
                                                                    </template>
                                                                    <span>{{'Add Calendar Insertion'|translate}}</span>
                                                                </v-tooltip>
                                                                <v-tooltip left>
                                                                    <template v-slot:activator="{ on }" >
                                                                        <v-icon
                                                                            class="mb-3 secondary pa-1"
                                                                            small
                                                                            v-on="on"
                                                                            @click="addSeriesInsertionByRef(payloadIndex)"
                                                                        >
                                                                            fa-sitemap
                                                                        </v-icon>
                                                                    </template>
                                                                    <span>{{'Add Series Insertion by Ref'|translate}}</span>
                                                                </v-tooltip>
                                                                <v-tooltip left>
                                                                    <template v-slot:activator="{ on }" >
                                                                        <v-icon
                                                                            class="mb-3 secondary pa-1"
                                                                            small
                                                                            v-on="on"
                                                                            @click="addSeriesInsert(payloadIndex)"
                                                                        >
                                                                            fa-plus-square
                                                                        </v-icon>
                                                                    </template>
                                                                    <span>{{'Add Series Insertion'|translate}}</span>
                                                                </v-tooltip>

                                                            </v-speed-dial>

                                                            <v-icon small class="mr-2"  v-if="payloadIndex>0" @click="arrmove(editChartConfig['data-payload'],payloadIndex,payloadIndex-1)">
                                                                fa-arrow-up
                                                            </v-icon>
                                                            <v-icon small class="mr-2"  v-if="payloadIndex<editChartConfig['data-payload'].length-1" @click="arrmove(editChartConfig['data-payload'],payloadIndex,payloadIndex+1)">
                                                                fa-arrow-down
                                                            </v-icon>

                                                            <v-icon
                                                                small
                                                                class="mr-2"
                                                                @click="copyQuery(payload)"
                                                            >
                                                                fa-copy
                                                            </v-icon>

                                                            <v-icon v-if="editChartConfig['data-payload'].length>1"
                                                                    small
                                                                    @click="deleteQuery(payloadIndex)"
                                                            >
                                                                fa-trash
                                                            </v-icon>
                                                        </v-card-title>
                                                        <v-card-text v-show="!payload.hideInBuilder" style="margin-bottom: 0 !important; padding-bottom: 0 !important;">
                                                            <v-layout row wrap>
                                                                <!-- 0311 -->
                                                                <v-flex xs3 class="pa-2" style="border-right: 3px solid grey">
                                                                    <v-autocomplete
                                                                        :items="scopedCombinations[payloadIndex].sensor_name"
                                                                        :label="'Sensor Name'|translate"
                                                                        v-model="payload.filters.sensor_name"
                                                                        required
                                                                        clearable
                                                                    ></v-autocomplete>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2">
                                                                    <v-autocomplete
                                                                        :items="scopedCombinations[payloadIndex].equipment_tags"
                                                                        :label="'Equipment Tags'|translate"
                                                                        v-model="payload.filters.equipment_tags"
                                                                        multiple
                                                                        clearable
                                                                    ></v-autocomplete>
                                                                </v-flex>
                                                                <v-flex xs2 class="pa-2">
                                                                    <v-autocomplete
                                                                        :items="scopedCombinations[payloadIndex].equipment_type"
                                                                        :label="'Equipment Type'|translate"
                                                                        v-model="payload.filters.equipment_type"
                                                                        clearable
                                                                    ></v-autocomplete>
                                                                </v-flex>
                                                                <v-flex xs2 class="pa-2">
                                                                    <v-autocomplete
                                                                        :items="scopedCombinations[payloadIndex].equipment_name"
                                                                        :label="'Equipment Name'|translate"
                                                                        v-model="payload.filters.equipment_name"
                                                                        clearable
                                                                    ></v-autocomplete>
                                                                </v-flex>
                                                                <v-flex xs2 class="pa-2">
                                                                    <v-autocomplete
                                                                        :items="scopedCombinations[payloadIndex].floor"
                                                                        :label="'Floor'|translate"
                                                                        v-model="payload.filters.floor"
                                                                        clearable
                                                                    ></v-autocomplete>
                                                                </v-flex>
                                                            </v-layout>
                                                            <v-layout row wrap v-if="payload.useCustomRange">
                                                                <v-flex xs3 class="pa-2">
                                                                    <h4 class="pt-4">{{'Custom range'|translate}}</h4>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2">
                                                                    <v-switch color="success"
                                                                              v-model="payload.useCustomRelativeRange"
                                                                              :label="'Use relative range'|translate"
                                                                    ></v-switch>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="!payload.useCustomRelativeRange">
                                                                    <date-range-selector v-model="payload.customRange"></date-range-selector>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="payload.useCustomRelativeRange">
                                                                    <v-select  :items="relativeRangeOptions"
                                                                               placeholder="30 days"
                                                                               :label="'Relative range'|translate" v-model="payload.customRelativeRange"></v-select>
                                                                </v-flex>
                                                                <v-flex xs2 class="pa-2" v-if="!payload.useCustomRelativeRange">
                                                                    <v-switch color="success" class="ml-5"
                                                                              v-model="payload.customRangeStartOnly"
                                                                              :label="'Start date only'|translate"
                                                                    ></v-switch>
                                                                </v-flex>

                                                            </v-layout>
                                                            <v-layout row wrap v-if="payload.offsetRange&&!payload.useCustomRange">
                                                                <v-flex xs3 class="pa-2">
                                                                    <h4 class="pt-4">{{'Range offset'|translate}}</h4>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2">
                                                                    <v-select
                                                                        :items="offsetTypes"
                                                                        :label="'Offset unit'|translate"
                                                                        v-model="payload.offsetType"
                                                                    ></v-select>
                                                                </v-flex>
                                                                <v-flex xs2 class="pa-2">
                                                                    <v-text-field v-model.number="payload.offsetAmount" type="number" :label="'Offset amount'|translate"></v-text-field>
                                                                </v-flex>
                                                                <v-flex xs2 class="pa-2" v-if="payload.offsetType==='year'||payload.offsetType==='years'">
                                                                    <v-text-field v-model.number="payload.offsetPreciseYear" type="number" :label="'Exact year'|translate"></v-text-field>
                                                                </v-flex>
                                                                <v-flex xs2 class="pa-2">
                                                                    <v-switch color="success"
                                                                              v-model="payload.offsetRangeStartOnly"
                                                                              :label="'Start date only'|translate"
                                                                    ></v-switch>
                                                                </v-flex>
                                                            </v-layout>
                                                            <v-layout row wrap v-if="payload.onOnly">
                                                                <v-flex xs3 class="pa-2">
                                                                    <h4 class="pt-4">{{'Filter'|translate}}</h4>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2 pt-4">
                                                                    * - on
                                                                </v-flex>
                                                                <v-flex xs2 class="pa-2 pt-4">
                                                                    =
                                                                </v-flex>
                                                                <v-flex xs2 class="pa-2 pt-4">
                                                                    1
                                                                </v-flex>
                                                                <v-flex xs2 class="pa-2">
                                                                </v-flex>
                                                            </v-layout>
                                                            <draggable v-model="payload.pipeline" :group="{ name: 'a', pull: false}" @add="applySettings" style="min-height:40px;" >
                                                                <div v-for="(pipelineStage,subindex) in payload.pipeline" style="margin-top:20px; margin-bottom: 20px;">
                                                                    <v-layout row wrap v-if="pipelineStage.type==='agg'">
                                                                        <v-flex xs3 class="pa-2">
                                                                            <h4 class="pt-4">{{'Time Aggregation'|translate}}</h4>
                                                                        </v-flex>
                                                                        <v-flex xs3 class="pa-2">
                                                                            <v-select
                                                                                :items="aggFreq"
                                                                                :label="'Frequency'|translate"
                                                                                v-model="pipelineStage.agg"
                                                                            ></v-select>
                                                                        </v-flex>
                                                                        <v-flex xs3 class="pa-2">
                                                                            <v-select
                                                                                :items="aggOpp"
                                                                                :label="'Operation'|translate"
                                                                                v-model="pipelineStage.agg_op"
                                                                            ></v-select>
                                                                        </v-flex>
                                                                        <v-flex xs3 class="pa-2">
                                                                            <v-layout row :class="pipelineStage.agg_op==='sum' ? '' : 'pt-4'">
                                                                                <v-switch color="success" v-if="pipelineStage.agg_op==='sum'"
                                                                                          v-model="pipelineStage.divide_by_sf"
                                                                                          :label="'Divide by sampling freq'|translate"
                                                                                ></v-switch>
                                                                                <v-spacer></v-spacer>
                                                                                <v-icon small class="mr-2"  v-if="subindex>0" @click="arrmove(payload.pipeline,subindex,subindex-1)">
                                                                                    fa-arrow-up
                                                                                </v-icon>
                                                                                <v-icon small class="mr-2"  v-if="subindex<payload.pipeline.length-1" @click="arrmove(payload.pipeline,subindex,subindex+1)">
                                                                                    fa-arrow-down
                                                                                </v-icon>
                                                                                <v-icon
                                                                                    small
                                                                                    @click="deleteFromPipeline(payloadIndex,subindex)"
                                                                                >
                                                                                    fa-trash
                                                                                </v-icon>

                                                                            </v-layout>

                                                                        </v-flex>


                                                                    </v-layout>
                                                                    <v-layout row wrap v-if="pipelineStage.type==='agg_h'">
                                                                        <v-flex xs3 class="pa-2">
                                                                            <h4 class="pt-4">{{'Horizontal Aggregation'|translate}}</h4>
                                                                        </v-flex>
                                                                        <v-flex xs3 class="pa-2">
                                                                            <v-select
                                                                                :items="aggOpp"
                                                                                :label="'Operation'|translate"
                                                                                v-model="pipelineStage.agg_op"
                                                                            ></v-select>
                                                                        </v-flex>
                                                                        <v-flex xs3 class="pa-2">
                                                                            <v-text-field clearable :value="pipelineStage.name" @change="v => pipelineStage.name = v" type="text" :label="'Name'|translate"></v-text-field>
                                                                        </v-flex>
                                                                        <v-flex xs3 class="pa-2">
                                                                            <v-layout row class="pt-4">
                                                                                <v-spacer></v-spacer>
                                                                                <v-icon small class="mr-2"  v-if="subindex>0" @click="arrmove(payload.pipeline,subindex,subindex-1)">
                                                                                    fa-arrow-up
                                                                                </v-icon>
                                                                                <v-icon small class="mr-2"  v-if="subindex<payload.pipeline.length-1" @click="arrmove(payload.pipeline,subindex,subindex+1)">
                                                                                    fa-arrow-down
                                                                                </v-icon>
                                                                                <v-icon
                                                                                    small
                                                                                    @click="deleteFromPipeline(payloadIndex,subindex)"
                                                                                >
                                                                                    fa-trash
                                                                                </v-icon>

                                                                            </v-layout>

                                                                        </v-flex>


                                                                    </v-layout>
                                                                    <v-layout row wrap v-if="pipelineStage.type==='insert_series'">
                                                                        <v-flex xs3 class="pa-2">
                                                                            <h4 class="pt-4">{{'Insert Series'|translate}}</h4>
                                                                        </v-flex>
                                                                        <v-flex xs6 class="pa-2">
                                                                            <!--                                                        <v-text-field v-model="pipelineStage.name" type="text" label="Series"></v-text-field>-->
                                                                            <sensor-selector v-model="pipelineStage.name"></sensor-selector>
                                                                        </v-flex>
                                                                        <v-flex xs3 class="pa-2">
                                                                            <v-layout row class="pt-4">
                                                                                <v-spacer></v-spacer>
                                                                                <v-icon small class="mr-2"  v-if="subindex>0" @click="arrmove(payload.pipeline,subindex,subindex-1)">
                                                                                    fa-arrow-up
                                                                                </v-icon>
                                                                                <v-icon small class="mr-2"  v-if="subindex<payload.pipeline.length-1" @click="arrmove(payload.pipeline,subindex,subindex+1)">
                                                                                    fa-arrow-down
                                                                                </v-icon>
                                                                                <v-icon
                                                                                    small
                                                                                    @click="deleteFromPipeline(payloadIndex,subindex)"
                                                                                >
                                                                                    fa-trash
                                                                                </v-icon>

                                                                            </v-layout>

                                                                        </v-flex>
                                                                    </v-layout>
                                                                    <v-layout row wrap v-if="pipelineStage.type==='insert_calendar'">
                                                                        <v-flex xs3 class="pa-2">
                                                                            <h4 class="pt-4">{{'Insert Calendar'|translate}}</h4>
                                                                        </v-flex>
                                                                        <v-flex xs6 class="pa-2">
                                                                            <v-text-field v-model="pipelineStage.name" type="text" label="Date Type"></v-text-field>
                                                                        </v-flex>
                                                                        <v-flex xs3 class="pa-2">
                                                                            <v-layout row class="pt-4">
                                                                                <v-spacer></v-spacer>
                                                                                <v-icon small class="mr-2"  v-if="subindex>0" @click="arrmove(payload.pipeline,subindex,subindex-1)">
                                                                                    fa-arrow-up
                                                                                </v-icon>
                                                                                <v-icon small class="mr-2"  v-if="subindex<payload.pipeline.length-1" @click="arrmove(payload.pipeline,subindex,subindex+1)">
                                                                                    fa-arrow-down
                                                                                </v-icon>
                                                                                <v-icon
                                                                                    small
                                                                                    @click="deleteFromPipeline(payloadIndex,subindex)"
                                                                                >
                                                                                    fa-trash
                                                                                </v-icon>
                                                                            </v-layout>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                    <v-layout row wrap v-if="pipelineStage.type==='filter'">
                                                                        <v-flex xs3 class="pa-2">
                                                                            <h4 class="pt-4">{{'Filter'|translate}}</h4>
                                                                        </v-flex>
                                                                        <v-flex xs3 class="pa-2">
                                                                            <v-combobox
                                                                                :items="getCalcStrings(payload,subindex,true)"
                                                                                :label="'Field'|translate"
                                                                                v-model="pipelineStage.filter_by"
                                                                            ></v-combobox>
                                                                        </v-flex>
                                                                        <v-flex xs2 class="pa-2">
                                                                            <v-select
                                                                                :items="filterOpp"
                                                                                :label="'Operation'|translate"
                                                                                v-model="pipelineStage.filter_op"
                                                                            ></v-select>
                                                                        </v-flex>
                                                                        <v-flex xs2 class="pa-2">
                                                                            <v-text-field :value="pipelineStage.filter_value" @change="v => pipelineStage.filter_value = parseFloat(v)"  type="number" :label="'Value'|translate"></v-text-field>
                                                                        </v-flex>
                                                                        <v-flex xs2 class="pa-2">
                                                                            <v-layout row class="pt-4">
                                                                                <v-spacer></v-spacer>
                                                                                <v-icon small class="mr-2"  v-if="subindex>0" @click="arrmove(payload.pipeline,subindex,subindex-1)">
                                                                                    fa-arrow-up
                                                                                </v-icon>
                                                                                <v-icon small class="mr-2"  v-if="subindex<payload.pipeline.length-1" @click="arrmove(payload.pipeline,subindex,subindex+1)">
                                                                                    fa-arrow-down
                                                                                </v-icon>
                                                                                <v-icon
                                                                                    small
                                                                                    @click="deleteFromPipeline(payloadIndex,subindex)"
                                                                                >
                                                                                    fa-trash
                                                                                </v-icon>

                                                                            </v-layout>

                                                                        </v-flex>


                                                                    </v-layout>
                                                                    <v-layout row wrap v-if="pipelineStage.type==='insert_series_by_ref'">
                                                                        <v-flex xs2 class="pa-2">
                                                                            <h4 class="pt-4">{{'Insert by ref'|translate}}</h4>
                                                                        </v-flex>
                                                                        <v-flex xs2 class="pa-2">
                                                                            <v-combobox
                                                                                :items="getPossibleEquipRelTypes(payload.filters.equipment_name)"
                                                                                :label="'Ref type'|translate"
                                                                                v-model="pipelineStage.ref_type"
                                                                            ></v-combobox>
                                                                        </v-flex>
                                                                        <v-flex xs2 class="pa-2">
                                                                            <v-combobox
                                                                                :items="getPossibleEquipRelCombos(payload.filters.equipment_name,pipelineStage.ref_type).equipment_type"
                                                                                :label="'Equipment_type'|translate"
                                                                                v-model="pipelineStage.equipment_type"
                                                                                clearable
                                                                            ></v-combobox>
                                                                        </v-flex>
                                                                        <v-flex xs2 class="pa-2">
                                                                            <v-combobox
                                                                                :items="getPossibleEquipRelCombos(payload.filters.equipment_name,pipelineStage.ref_type).sensor_name"
                                                                                :label="'Sensor Name'|translate"
                                                                                v-model="pipelineStage.sensor_name"
                                                                            ></v-combobox>
                                                                        </v-flex>
                                                                        <v-flex xs2 class="pa-2">
                                                                            <v-switch color="success"
                                                                                      v-model="pipelineStage.remove_others"
                                                                                      :label="'Remove Others'|translate"
                                                                            ></v-switch>
                                                                        </v-flex>

                                                                        <v-flex xs2 class="pa-2">
                                                                            <v-layout row class="pt-4">
                                                                                <v-spacer></v-spacer>
                                                                                <v-icon small class="mr-2"  v-if="subindex>0" @click="arrmove(payload.pipeline,subindex,subindex-1)">
                                                                                    fa-arrow-up
                                                                                </v-icon>
                                                                                <v-icon small class="mr-2"  v-if="subindex<payload.pipeline.length-1" @click="arrmove(payload.pipeline,subindex,subindex+1)">
                                                                                    fa-arrow-down
                                                                                </v-icon>
                                                                                <v-icon
                                                                                    small
                                                                                    @click="deleteFromPipeline(payloadIndex,subindex)"
                                                                                >
                                                                                    fa-trash
                                                                                </v-icon>

                                                                            </v-layout>

                                                                        </v-flex>


                                                                    </v-layout>
                                                                    <v-layout row wrap v-if="pipelineStage.type==='calculate'">

                                                                        <v-flex xs3 class="pa-2">
                                                                            <h4 class="pt-4">{{'Series Calculation'|translate}}</h4>
                                                                        </v-flex>

                                                                        <v-flex xs4 class="pa-2">
                                                                            <v-text-field :value="pipelineStage.name" @change="v => pipelineStage.name = v" type="text" :label="'Name'|translate"></v-text-field>
                                                                        </v-flex>

                                                                        <v-flex xs4 class="pa-2">
                                                                            <v-switch color="success"
                                                                                      v-model="pipelineStage.remove_others"
                                                                                      :label="'Remove Others'|translate"
                                                                            ></v-switch>
                                                                        </v-flex>

                                                                        <v-flex xs1 class="pa-2">
                                                                            <v-layout row class="pt-4">
                                                                                <v-spacer></v-spacer>
                                                                                <v-icon small class="mr-2"  v-if="subindex>0" @click="arrmove(payload.pipeline,subindex,subindex-1)">
                                                                                    fa-arrow-up
                                                                                </v-icon>
                                                                                <v-icon small class="mr-2"  v-if="subindex<payload.pipeline.length-1" @click="arrmove(payload.pipeline,subindex,subindex+1)">
                                                                                    fa-arrow-down
                                                                                </v-icon>
                                                                                <v-icon
                                                                                    small
                                                                                    @click="deleteFromPipeline(payloadIndex,subindex)"
                                                                                >
                                                                                    fa-trash
                                                                                </v-icon>

                                                                            </v-layout>

                                                                        </v-flex>
                                                                        <v-flex xs3></v-flex>
                                                                        <v-flex xs9  class="pa-2">
                                                                            <v-chip  v-for="item in getCalcStrings(payload,subindex)"
                                                                                     label @click="addToFormula(pipelineStage,item)"
                                                                            >
                                                                                {{item}}
                                                                            </v-chip>
                                                                            <v-chip  v-for="item in availableParameters"
                                                                                     label @click="addParamToFormula(pipelineStage,item)"
                                                                            >
                                                                                {{item}}
                                                                            </v-chip>
                                                                        </v-flex>
                                                                        <v-flex xs3></v-flex>
                                                                        <v-flex xs9  class="pa-2">
                                                                            <v-textarea auto-grow rows="3" :value="pipelineStage.formula" @change="v => pipelineStage.formula = v" :label="'Formula'|translate"></v-textarea>
                                                                        </v-flex>


                                                                    </v-layout>
                                                                    <v-layout row wrap v-if="pipelineStage.type==='calculate_global'">
                                                                        <v-flex xs2 class="pa-2">
                                                                            <h4 class="pt-4">{{'Dataframe Transformation'|translate}}</h4>
                                                                        </v-flex>
                                                                        <v-flex xs1 class="pa-2" style="text-align: right">
                                                                            <h4 class="pt-4">df =</h4>
                                                                        </v-flex>

                                                                        <v-flex xs8 class="pa-2">
                                                                            <v-textarea auto-grow rows="1" :value="pipelineStage.formula" @change="v => pipelineStage.formula = v" :label="'Formula'|translate"></v-textarea>
                                                                        </v-flex>
                                                                        <v-flex xs1 class="pa-2">
                                                                            <v-layout row class="pt-4">
                                                                                <v-spacer></v-spacer>
                                                                                <v-icon small class="mr-2"  v-if="subindex>0" @click="arrmove(payload.pipeline,subindex,subindex-1)">
                                                                                    fa-arrow-up
                                                                                </v-icon>
                                                                                <v-icon small class="mr-2"  v-if="subindex<payload.pipeline.length-1" @click="arrmove(payload.pipeline,subindex,subindex+1)">
                                                                                    fa-arrow-down
                                                                                </v-icon>
                                                                                <v-icon
                                                                                    small
                                                                                    @click="deleteFromPipeline(payloadIndex,subindex)"
                                                                                >
                                                                                    fa-trash
                                                                                </v-icon>
                                                                            </v-layout>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                    <v-layout row wrap v-if="pipelineStage.type==='notes'">
                                                                        <v-flex xs2 class="pa-2">
                                                                            <h4 class="pt-4">{{'Notes'|translate}}</h4>
                                                                        </v-flex>
                                                                        <v-flex xs1 class="pa-2">
                                                                        </v-flex>
                                                                        <v-flex xs8 class="pa-2">
                                                                            <v-textarea auto-grow rows="1" :value="pipelineStage.text" @change="v => pipelineStage.text = v"></v-textarea>
                                                                        </v-flex>
                                                                        <v-flex xs1 class="pa-2">
                                                                            <v-layout row class="pt-4">
                                                                                <v-spacer></v-spacer>
                                                                                <v-icon small class="mr-2"  v-if="subindex>0" @click="arrmove(payload.pipeline,subindex,subindex-1)">
                                                                                    fa-arrow-up
                                                                                </v-icon>
                                                                                <v-icon small class="mr-2"  v-if="subindex<payload.pipeline.length-1" @click="arrmove(payload.pipeline,subindex,subindex+1)">
                                                                                    fa-arrow-down
                                                                                </v-icon>
                                                                                <v-icon
                                                                                    small
                                                                                    @click="deleteFromPipeline(payloadIndex,subindex)"
                                                                                >
                                                                                    fa-trash
                                                                                </v-icon>
                                                                            </v-layout>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                    <v-layout row wrap v-if="pipelineStage.type==='convert_to_enum'">
                                                                        <v-flex xs2 class="pa-2">
                                                                            <h4 class="pt-4">{{'Convert to enum'|translate}}</h4>
                                                                        </v-flex>
                                                                        <v-flex xs8 class="pa-2">
                                                                        </v-flex>
                                                                        <v-flex xs1 class="pa-2">
                                                                            <v-layout row class="pt-4">
                                                                                <v-spacer></v-spacer>
                                                                                <v-icon small class="mr-2"  v-if="subindex>0" @click="arrmove(payload.pipeline,subindex,subindex-1)">
                                                                                    fa-arrow-up
                                                                                </v-icon>
                                                                                <v-icon small class="mr-2"  v-if="subindex<payload.pipeline.length-1" @click="arrmove(payload.pipeline,subindex,subindex+1)">
                                                                                    fa-arrow-down
                                                                                </v-icon>
                                                                                <v-icon
                                                                                    small
                                                                                    @click="deleteFromPipeline(payloadIndex,subindex)"
                                                                                >
                                                                                    fa-trash
                                                                                </v-icon>

                                                                            </v-layout>

                                                                        </v-flex>


                                                                    </v-layout>
                                                                    <v-layout row wrap v-if="pipelineStage.type==='select_series'">
                                                                        <v-flex xs2 class="pa-2">
                                                                            <h4 class="pt-4">{{'Series Selection'|translate}}</h4>
                                                                        </v-flex>
                                                                        <v-flex xs5 class="pa-2">
                                                                            <draggable v-model="pipelineStage.series" group="g">
                                                                                <v-chip close v-for="(j, index) in pipelineStage.series"
                                                                                        @input="pipelineStage.series.splice(index, 1)"
                                                                                        label
                                                                                >
                                                                                    {{j}}
                                                                                </v-chip>
                                                                            </draggable>

                                                                        </v-flex>
                                                                        <v-flex xs4 class="pa-2">
                                                                            <v-layout row>
                                                                                <v-autocomplete
                                                                                    :items="getCalcStrings(payload,subindex,true)"
                                                                                    :label="'Add Series'|translate"
                                                                                    v-model="pipelineStage.newSeries"
                                                                                ></v-autocomplete>
                                                                                <v-btn color="primary" :disabled="!pipelineStage.newSeries||pipelineStage.newSeries==''" @click="pipelineStage.series.push(pipelineStage.newSeries); pipelineStage.newSeries=null">{{'Add'|translate}}</v-btn>
                                                                            </v-layout>

                                                                        </v-flex>
                                                                        <v-flex xs1 class="pa-2">
                                                                            <v-layout row class="pt-4">
                                                                                <v-spacer></v-spacer>
                                                                                <v-icon small class="mr-2"  v-if="subindex>0" @click="arrmove(payload.pipeline,subindex,subindex-1)">
                                                                                    fa-arrow-up
                                                                                </v-icon>
                                                                                <v-icon small class="mr-2"  v-if="subindex<payload.pipeline.length-1" @click="arrmove(payload.pipeline,subindex,subindex+1)">
                                                                                    fa-arrow-down
                                                                                </v-icon>
                                                                                <v-icon
                                                                                    small
                                                                                    @click="deleteFromPipeline(payloadIndex,subindex)"
                                                                                >
                                                                                    fa-trash
                                                                                </v-icon>

                                                                            </v-layout>

                                                                        </v-flex>


                                                                    </v-layout>
                                                                </div>
                                                            </draggable>


                                                        </v-card-text>
                                                        <v-card-text v-show="!payload.filters.sensor_name&&!payload.filters.equipment_name">
                                                            <v-alert
                                                                :value="true"
                                                                type="warning"
                                                                style="padding: 6px;"
                                                            >
                                                                {{'Please select a Sensor Name or an Equipment Name'|translate}}
                                                            </v-alert>
                                                        </v-card-text>
                                                        <v-card-text v-if="payload.filters.sensor_name||payload.filters.equipment_name">
                                                            <v-alert v-if="getCalcStrings(payload,99,true).length>0"
                                                                     :value="true"
                                                                     style="padding: 6px;"
                                                                     type="success"
                                                            >
                                                                {{'Returned series : '|translate}}
                                                                <v-chip close v-for="series in getCalcStrings(payload,99,true)" @input="handleRSClick(payload,series)">{{series}}</v-chip>
                                                            </v-alert>
                                                            <v-alert v-if="getCalcStrings(payload,99,true).length===0"
                                                                     :value="true"
                                                                     type="error"
                                                                     style="padding: 6px;"
                                                            >
                                                                {{'This query returns no series'|translate}}
                                                            </v-alert>
                                                            <v-alert v-if="payload.seriesOverrides.type&&aggTypicalTypes.indexOf(payload.seriesOverrides.type)>-1&&(!payload.pipeline||payload.pipeline.filter(x=>x.type==='agg').length===0)"
                                                                     :value="true"
                                                                     type="warning"
                                                                     style="padding: 6px;"
                                                            >
                                                                {{'No time aggregation. Last value will be used.'|translate}}
                                                            </v-alert>
                                                        </v-card-text>
                                                        <v-card-title v-if="!headlessMode" class="white--text subheading" v-show="!payload.hideInBuilder&&!isPayloadAnAxis(payload)&&(payload.filters.sensor_name||payload.filters.equipment_name)">
                                                            {{'Layout'|translate}}
                                                            <v-tooltip bottom v-if="payload.showLayoutOptions">
                                                                <template v-slot:activator="{ on }" >
                                                                    <v-icon
                                                                        class="ml-2 mr-2"
                                                                        small
                                                                        v-on="on"
                                                                        @click="$set(payload,'showLayoutOptions',false)"
                                                                    >
                                                                        fa-chevron-up
                                                                    </v-icon>
                                                                </template>
                                                                <span>{{'Collapse'|translate}}</span>
                                                            </v-tooltip>
                                                            <v-tooltip bottom v-if="!payload.showLayoutOptions">
                                                                <template v-slot:activator="{ on }" >
                                                                    <v-icon
                                                                        class="ml-2 mr-2"
                                                                        small
                                                                        v-on="on"
                                                                        @click="$set(payload,'showLayoutOptions',true)"
                                                                    >
                                                                        fa-chevron-down
                                                                    </v-icon>
                                                                </template>
                                                                <span>{{'Expand'|translate}}</span>
                                                            </v-tooltip>
                                                            <v-divider></v-divider>
                                                        </v-card-title>
                                                        <v-card-text v-if="!headlessMode" v-show="payload.showLayoutOptions&&!payload.hideInBuilder&&!isPayloadAnAxis(payload)&&(payload.filters.sensor_name||payload.filters.equipment_name)">
                                                            <v-layout row wrap>
                                                                <v-flex xs3 class="pa-2">
                                                                    <v-select
                                                                        :items="seriesTypes"
                                                                        :label="'Chart Type'|translate"
                                                                        v-model="payload.seriesOverrides.type"
                                                                    ></v-select>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type==='scatter'||payload.seriesOverrides.type==='scatter3d'||payload.seriesOverrides.type==='scatterpolar'">
                                                                    <v-select
                                                                        :items="scatterModes"
                                                                        :label="'Trace Type'|translate"
                                                                        v-model="payload.seriesOverrides.mode"
                                                                        clearable
                                                                    ></v-select>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type==='scatter'&&payload.seriesOverrides.mode==='markers'">
                                                                    <v-text-field
                                                                        :label="'Custom marker'|translate" v-model="payload.seriesOverrides.markerSymbol" clearable
                                                                    ></v-text-field>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type==='indicator'">
                                                                    <v-select
                                                                        :items="indicatorModes"
                                                                        :label="'Indicator Mode'|translate"
                                                                        v-model="payload.seriesOverrides.mode"
                                                                        clearable
                                                                    ></v-select>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type==='indicator'">
                                                                    <v-text-field
                                                                        :label="'Number Size'|translate" type="number" v-model.number="payload.seriesOverrides.numberSize" clearable
                                                                    ></v-text-field>
                                                                </v-flex>
                                                              <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type==='indicator'">
                                                                    <v-text-field
                                                                        :label="'Number Format'|translate" v-model="payload.seriesOverrides.carnotNumberFormat" clearable
                                                                    ></v-text-field>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type==='indicator'&&payload.seriesOverrides.mode==='gauge+number'">
                                                                    <v-text-field
                                                                        :label="'Gauge Min'|translate" type="number" v-model.number="payload.seriesOverrides.gaugeMin"
                                                                    ></v-text-field>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type==='indicator'&&payload.seriesOverrides.mode==='gauge+number'">
                                                                    <v-text-field
                                                                        :label="'Gauge Max'|translate" type="number" v-model.number="payload.seriesOverrides.gaugeMax"
                                                                    ></v-text-field>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type==='indicator'&&payload.seriesOverrides.mode==='gauge+number'">
                                                                    <v-text-field
                                                                        :label="'Bar color'|translate" v-model="payload.seriesOverrides.barColor"
                                                                    ></v-text-field>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type==='indicator'&&payload.seriesOverrides.mode==='gauge+number'">
                                                                    <v-text-field
                                                                        :label="'Border color'|translate" v-model="payload.seriesOverrides.borderColor"
                                                                    ></v-text-field>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type==='indicator'&&payload.seriesOverrides.mode==='gauge+number'">
                                                                    <v-select
                                                                        :items="['angular','bullet']"
                                                                        :label="'Shape'|translate"
                                                                        v-model="payload.seriesOverrides.gaugeShape"
                                                                        clearable
                                                                    ></v-select>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type==='indicator'&&payload.seriesOverrides.mode==='gauge+number'">
                                                                    <v-text-field
                                                                        :label="'Background color'|translate" v-model="payload.seriesOverrides.bgColor"
                                                                    ></v-text-field>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type==='scatter'&&payload.seriesOverrides.mode!=='markers'">
                                                                    <v-select
                                                                        :items="fillModes"
                                                                        :label="'Fill'|translate"
                                                                        v-model="payload.seriesOverrides.fill"
                                                                        clearable
                                                                    ></v-select>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type==='scatter'&&payload.seriesOverrides.mode!=='markers'">
                                                                    <v-switch color="success"
                                                                              v-model="payload.seriesOverrides.connectgaps"
                                                                              :label="'Connect gaps'|translate"
                                                                    ></v-switch>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type==='scatterpolar'">
                                                                    <v-select
                                                                        :items="polarFillModes"
                                                                        :label="'Fill'|translate"
                                                                        v-model="payload.seriesOverrides.fill"
                                                                        clearable
                                                                    ></v-select>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="(payload.seriesOverrides.type==='scatter'&&payload.seriesOverrides.mode!=='markers')&&payload.seriesOverrides.fill">
                                                                    <v-text-field
                                                                        :label="'Fill color'|translate" v-model="payload.seriesOverrides.fillcolor" clearable
                                                                    ></v-text-field>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type==='bar'||payload.seriesOverrides.type==='histogram'||payload.seriesOverrides.type==='bar summary'||payload.seriesOverrides.type==='barpolar'">
                                                                    <v-select
                                                                        :items="barModes"
                                                                        :label="'Bar Mode'|translate"
                                                                        v-model="editChartConfig['layout-overrides'].barmode"
                                                                    ></v-select>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type==='histogram'">
                                                                    <v-select
                                                                        :items="histnorms"
                                                                        :label="'Normalization'|translate"
                                                                        v-model="payload.seriesOverrides.histnorm"
                                                                        clearable
                                                                    ></v-select>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="editChartConfig['layout-overrides'].yaxis2&&(payload.seriesOverrides.type==='bar'||payload.seriesOverrides.type==='scatter')">
                                                                    <v-select
                                                                        :items="yAxisChoices"
                                                                        :label="'Y Axis'|translate"
                                                                        v-model="payload.seriesOverrides.yaxis"
                                                                    ></v-select>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type==='bar'||payload.seriesOverrides.type==='scatter'||payload.seriesOverrides.type==='bar summary'">
                                                                    <v-select clearable v-model="payload.seriesOverrides.stackgroup"
                                                                              type="text"
                                                                              :items="stackGroups"
                                                                              :label="'Stack Group'|translate"></v-select>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type==='bar'||payload.seriesOverrides.type==='bar summary'">
                                                                    <v-switch color="success"
                                                                              v-model="payload.seriesOverrides.showValuesOnBars"
                                                                              :label="'Display value'|translate"
                                                                    ></v-switch>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type==='scatter summary'||payload.seriesOverrides.type==='bar summary'">
                                                                    <v-switch color="success"
                                                                              v-model="payload.seriesOverrides.disableStacking"
                                                                              :label="'Disable query stacking'|translate"
                                                                    ></v-switch>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type==='scatter summary'||payload.seriesOverrides.type==='bar summary'||payload.seriesOverrides.type==='pie'||payload.seriesOverrides.type==='parallel coordinates'||payload.seriesOverrides.type==='heatmap'">
                                                                    <v-switch color="success"
                                                                              v-model="payload.seriesOverrides.equipOnlyName"
                                                                              :label="'Equipment-only name'|translate"
                                                                    ></v-switch>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type==='scatter summary'||payload.seriesOverrides.type==='bar summary'||payload.seriesOverrides.type==='barpolar'||payload.seriesOverrides.type==='scatterpolar'">
                                                                    <v-text-field  clearable
                                                                                   label="Legend name" v-model.number="payload.seriesOverrides.nameOverride"
                                                                    ></v-text-field>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type==='bar'">
                                                                    <v-switch color="success"
                                                                              v-model="payload.seriesOverrides.horizontalBarMode"
                                                                              :label="'Horizontal bars'|translate"
                                                                    ></v-switch>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type==='scatter summary'||payload.seriesOverrides.type==='bar summary'">
                                                                    <v-switch color="success"
                                                                              v-model="payload.seriesOverrides.horizontalSummaryMode"
                                                                              :label="'Horizontal mode'|translate"
                                                                    ></v-switch>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type==='heatmap'||payload.seriesOverrides.type==='histogram2d'||payload.seriesOverrides.type==='parallel coordinates'">
                                                                    <v-switch color="success"
                                                                              v-model="payload.seriesOverrides.showscale"
                                                                              :label="'Show Scale'|translate"
                                                                    ></v-switch>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type==='scatter'&&editChartConfig['x-axis']!=='timestamp'">
                                                                    <v-switch color="success"
                                                                              v-model="payload.seriesOverrides.renderAsSmoothLine"
                                                                              :label="'Render as Smooth Line'|translate"
                                                                    ></v-switch>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="(payload.seriesOverrides.type==='scatter'||payload.seriesOverrides.type==='scatter3d')&&editChartConfig['marker-size-axis']&&payload.seriesOverrides.mode==='markers'">
                                                                    <v-text-field  type="number" placeholder="40" clearable
                                                                                   label="Max Marker Size" v-model.number="payload.seriesOverrides.maxMarkerSize"
                                                                    ></v-text-field>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="(payload.seriesOverrides.type==='scatter'||payload.seriesOverrides.type==='scatter3d')&&editChartConfig['marker-size-axis']&&payload.seriesOverrides.mode==='markers'">
                                                                    <v-text-field  type="number" placeholder="0" clearable
                                                                                   label="Min Marker Size" v-model.number="payload.seriesOverrides.minMarkerSize"
                                                                    ></v-text-field>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="(payload.seriesOverrides.type==='scatter'||payload.seriesOverrides.type==='scatter3d')&&editChartConfig['marker-size-axis']&&payload.seriesOverrides.mode==='markers'">
                                                                    <v-switch color="success"
                                                                              v-model="payload.seriesOverrides.hideBorder"
                                                                              :label="'Hide Marker Border'|translate"
                                                                    ></v-switch>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type==='scatter'&&editChartConfig['x-axis']!=='timestamp'&&payload.seriesOverrides.renderAsSmoothLine">
                                                                    <v-text-field  type="number" placeholder="0.6" clearable
                                                                                   label="Smooth Line Span" v-model.number="payload.seriesOverrides.smoothLineSpan"
                                                                    ></v-text-field>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type==='scatter'&&editChartConfig['x-axis']!=='timestamp'&&payload.seriesOverrides.renderAsSmoothLine">
                                                                    <v-text-field  type="number" placeholder="0.8" clearable
                                                                                   label="Smooth Line Band" v-model.number="payload.seriesOverrides.smoothLineBand"
                                                                    ></v-text-field>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type==='scatter'&&editChartConfig['x-axis']!=='timestamp'&&payload.seriesOverrides.renderAsSmoothLine">
                                                                    <v-text-field  type="number" placeholder="1" clearable
                                                                                   label="Smooth Line Degree" v-model.number="payload.seriesOverrides.smoothLineDegree"
                                                                    ></v-text-field>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type==='heatmap'||payload.seriesOverrides.type==='histogram2d'">
                                                                    <v-autocomplete
                                                                        :items="colorscales"
                                                                        :label="'Custom Color Gradient'|translate"
                                                                        v-model="payload.seriesOverrides.colorscale"
                                                                        clearable
                                                                    ></v-autocomplete>
                                                                </v-flex>
                                                              <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type==='heatmap'">
                                                                <v-text-field  type="number" clearable
                                                                               label="Color scale min" v-model.number="payload.seriesOverrides.heatmapZmin"
                                                                ></v-text-field>
                                                              </v-flex>
                                                              <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type==='heatmap'">
                                                                <v-text-field  type="number" clearable
                                                                               label="Color scale max" v-model.number="payload.seriesOverrides.heatmapZmax"
                                                                ></v-text-field>
                                                              </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type==='pie'">
                                                                    <v-slider
                                                                        :label="'Donut'|translate" v-model.number="payload.seriesOverrides.hole"
                                                                        :min="0"
                                                                        :max="1"
                                                                        :step="0.1"
                                                                        thumb-label
                                                                    ></v-slider>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type==='box'">
                                                                    <v-select clearable v-model="payload.seriesOverrides.boxpoints"
                                                                              type="text"
                                                                              :items="['all','suspectedoutliers','Outliers']"
                                                                              :label="'Box Points'|translate"></v-select>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type==='box'||payload.seriesOverrides.type==='violin'">
                                                                    <v-switch color="success"
                                                                              v-model="payload.seriesOverrides.horizontalBox"
                                                                              :label="'Horizontal'|translate"
                                                                    ></v-switch>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type==='histogram'||payload.seriesOverrides.type==='histogram2d'">
                                                                    <v-text-field  type="number"
                                                                                   :label="'Xbins Size'|translate" v-model.number="payload.seriesOverrides.xbins.size"
                                                                    ></v-text-field>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type==='histogram2d'&&payload.seriesOverrides.ybins">
                                                                    <v-text-field  type="number"
                                                                                   :label="'Ybins Size'|translate" v-model.number="payload.seriesOverrides.ybins.size"
                                                                    ></v-text-field>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type!=='indicator'">
                                                                    <v-slider
                                                                        :label="'Opacity'|translate" v-model.number="payload.seriesOverrides.opacity"
                                                                        :min="0"
                                                                        :max="1"
                                                                        :step="0.1"
                                                                        thumb-label
                                                                    ></v-slider>
                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2" v-if="payload.seriesOverrides.type==='indicator'||payload.seriesOverrides.type==='bar summary'">
                                                                    <v-btn color="primary"  v-if="!payload.seriesOverrides.steps" @click="$set(payload.seriesOverrides, 'steps', [{range: [0, 1], color: 'gray'}])">{{'Add step'|translate}}</v-btn>
                                                                    <v-btn color="primary"  v-if="payload.seriesOverrides.steps" @click="payload.seriesOverrides.steps.push({range: [0, 1], color: 'gray'}) ">{{'Add step'|translate}}</v-btn>
                                                                </v-flex>
                                                                <v-flex xs12 v-if="(payload.seriesOverrides.type==='indicator'||payload.seriesOverrides.type==='bar summary')&&payload.seriesOverrides.steps&&payload.seriesOverrides.steps.length>0">
                                                                    <v-layout row wrap>
                                                                        <v-flex xs12>
                                                                            <v-card-title class="accent white--text subheading">
                                                                                {{'Color Steps'|translate}}
                                                                            </v-card-title>
                                                                        </v-flex>

                                                                        <v-flex xs6 v-for="(step, stepindex) in payload.seriesOverrides.steps">
                                                                            <v-layout row>
                                                                                <v-flex xs3 class="pa-2">
                                                                                    <v-text-field v-model.number="step.range[0]" type="number" :label="'Min'|translate"></v-text-field>
                                                                                </v-flex>
                                                                                <v-flex xs3 class="pa-2">
                                                                                    <v-text-field v-model.number="step.range[1]" type="number" :label="'Max'|translate"></v-text-field>
                                                                                </v-flex>
                                                                                <v-flex xs4 class="pa-2">
                                                                                    <v-text-field v-model="step.color" type="text" :label="'Color'|translate"></v-text-field>
                                                                                </v-flex>
                                                                                <v-flex xs2 class="pa-2 pt-4">
                                                                                    <v-icon small @click="payload.seriesOverrides.steps.splice(stepindex, 1)">fa-trash</v-icon>
                                                                                </v-flex>
                                                                            </v-layout>
                                                                        </v-flex>
                                                                    </v-layout>

                                                                </v-flex>
                                                                <v-flex xs3 class="pa-2">
                                                                    <v-text-field  type="text"
                                                                                   :label="'Custom Unit'|translate" clearable v-model="payload.seriesOverrides.customUnit"
                                                                    ></v-text-field>
                                                                </v-flex>

                                                            </v-layout>
                                                        </v-card-text>

                                                    </v-card>
                                                </div>
                                            </draggable>
                                        </v-flex>


                                    </v-layout>
                                </v-flex>
                            </v-layout>

                        </v-flex>
                        <v-flex xs3 v-if="!headlessMode">
                            <v-card>
                                <v-card-text>
                                    <v-text-field clearable v-model="editChartConfig['layout-overrides'].title" type="text" :label="'Title'|translate"></v-text-field>
                                    <v-textarea clearable v-model="editChartConfig['layout-overrides'].carnotDescription" type="text" :label="'Description'|translate"></v-textarea>
                                    <v-expansion-panel v-model="panel">
                                        <v-expansion-panel-content class="accent">
                                            <template v-slot:header>
                                                <v-card-title class="accent white--text subheading">
                                                    {{'Presets'|translate}}
                                                </v-card-title>
                                            </template>
                                            <v-card>
                                                <v-container fluid>
                                                    <v-layout wrap align-center justify-center >
                                                        <v-flex v-for="preset in quickLayouts" xs4 >
                                                            <v-hover v-slot:default="{ hover }">
                                                                <v-card
                                                                    height="90px"
                                                                    class="pa-2 ma-1 cursor-as-pointer"
                                                                    @click="applyLayoutPreset(preset)"
                                                                    :elevation="hover ? 12 : 2"
                                                                    :class="{ 'on-hover': hover }">
                                                                    <v-icon large class="ma-2 layout justify-center">
                                                                        {{preset.icon}}
                                                                    </v-icon>
                                                                    <b class="layout justify-center" > {{preset.name|translate}} </b>
                                                                </v-card>
                                                            </v-hover>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-container>
                                            </v-card>
                                        </v-expansion-panel-content>
                                        <v-expansion-panel-content class="accent">
                                            <template v-slot:header>
                                                <v-card-title class="accent white--text subheading">
                                                    {{'Layout'|translate}}
                                                </v-card-title>
                                            </template>
                                            <v-card>
                                                <v-card-text>
                                                    <v-text-field clearable :label="'Height'|translate" type="number"
                                                                  v-model.number="editChartConfig['layout-overrides'].height"></v-text-field>
                                                    <v-text-field clearable :label="'Top Margin'|translate" type="number"
                                                                  v-model.number="editChartConfig['layout-overrides'].margin.t"></v-text-field>
                                                    <v-text-field clearable :label="'Left Margin'|translate" type="number"
                                                                  v-model.number="editChartConfig['layout-overrides'].margin.l"></v-text-field>
                                                    <v-text-field clearable :label="'Right Margin'|translate" type="number"
                                                                  v-model.number="editChartConfig['layout-overrides'].margin.r"></v-text-field>
                                                    <v-text-field clearable :label="'Bottom Margin'|translate" type="number"
                                                                  v-model.number="editChartConfig['layout-overrides'].margin.b"></v-text-field>
                                                    <v-select
                                                            :items="hovermode"
                                                            :label="'Hover Tooltip Behaviour'|translate"
                                                            v-model="editChartConfig['layout-overrides'].hovermode"
                                                    ></v-select>
                                                    <v-switch color="success"
                                                              v-model="editChartConfig['layout-overrides'].showlegend"
                                                              :label="'Show Legend'|translate"
                                                    ></v-switch>
                                                    <v-select
                                                        :items="legendModes"
                                                        :label="'Legend Position'|translate"
                                                        v-if="editChartConfig['layout-overrides'].showlegend"
                                                        v-model="editChartConfig['layout-overrides'].automatedLegendPosition"
                                                        clearable
                                                    ></v-select>
                                                </v-card-text>
                                            </v-card>
                                        </v-expansion-panel-content>
                                        <v-expansion-panel-content class="accent">
                                            <template v-slot:header>
                                                <v-card-title class="accent white--text subheading">
                                                    {{'Colors'|translate}}
                                                </v-card-title>
                                            </template>
                                            <v-card>
                                                <v-card-text>
                                                    <draggable v-model="editChartConfig['layout-overrides'].colorway" group="k">
                                                        <v-chip close v-for="(j, index) in editChartConfig['layout-overrides'].colorway" :color="j"
                                                                @input="editChartConfig['layout-overrides'].colorway.splice(index, 1)"
                                                                label
                                                        >
                                                            {{j}}
                                                        </v-chip>
                                                    </draggable>
                                                    <v-layout row>
                                                        <v-text-field :label="'Add Color'|translate" type="text"
                                                                      v-model="newColor"></v-text-field>
                                                        <v-btn color="primary" :disabled="!newColor||newColor==''" @click="editChartConfig['layout-overrides'].colorway.push(newColor); newColor=null">{{'Add'|translate}}</v-btn>
                                                    </v-layout>
                                                </v-card-text>
                                            </v-card>
                                        </v-expansion-panel-content>
                                        <v-expansion-panel-content class="accent">
                                            <template v-slot:header>
                                                <v-card-title class="accent white--text subheading">
                                                    {{'Axis settings'|translate}}
                                                </v-card-title>
                                            </template>
                                            <v-card>
                                                <v-card-text>

                                                <v-select
                                                        :items="axisPotentialValues"
                                                        :label="'X Axis Field'|translate"
                                                        v-model="editChartConfig['x-axis']"
                                                ></v-select>
                                                <v-switch color="success"
                                                          v-model="editChartConfig['independent-x']"
                                                          :label="'Independent X Series per Query'|translate"
                                                ></v-switch>
                                                <v-text-field clearable v-model="editChartConfig['layout-overrides'].xaxis.title" type="text" :label="'X Axis Label'|translate"></v-text-field>
                                                    <v-combobox
                                                        :items="tickFormatOptions"
                                                        clearable
                                                        :label="'X Axis Format'|translate"
                                                        v-model="editChartConfig['layout-overrides'].xaxis.tickformat"
                                                    >
                                                        <template v-slot:append>
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on }" >
                                                                    <v-icon
                                                                        v-on="on"
                                                                    >
                                                                        fa-info-circle
                                                                    </v-icon>
                                                                </template>
                                                                <div>
                                                                    %a - abbreviated weekday name.<br>
                                                                    %A - full weekday name<br>
                                                                    %b - abbreviated month name<br>
                                                                    %B - full month name<br>
                                                                    %c - the locale’s date and time, such as %x, %X<br>
                                                                    %d - zero-padded day of the month as a decimal number [01,31]<br>
                                                                    %e - space-padded day of the month as a decimal number [ 1,31]; equivalent to %_d<br>
                                                                    %f - microseconds as a decimal number [000000, 999999]<br>
                                                                    %g - ISO 8601 week-based year without century as a decimal number [00,99]<br>
                                                                    %G - ISO 8601 week-based year with century as a decimal number<br>
                                                                    %H - hour (24-hour clock) as a decimal number [00,23]<br>
                                                                    %I - hour (12-hour clock) as a decimal number [01,12]<br>
                                                                    %j - day of the year as a decimal number [001,366]<br>
                                                                    %m - month as a decimal number [01,12]<br>
                                                                    %M - minute as a decimal number [00,59]<br>
                                                                    %L - milliseconds as a decimal number [000, 999]<br>
                                                                    %p - either AM or PM<br>
                                                                    %q - quarter of the year as a decimal number [1,4]<br>
                                                                    %Q - milliseconds since UNIX epoch<br>
                                                                    %s - seconds since UNIX epoch<br>
                                                                    %S - second as a decimal number [00,61]<br>
                                                                    %u - Monday-based (ISO 8601) weekday as a decimal number [1,7]<br>
                                                                    %U - Sunday-based week of the year as a decimal number [00,53]<br>
                                                                    %V - ISO 8601 week of the year as a decimal number [01, 53]<br>
                                                                    %w - Sunday-based weekday as a decimal number [0,6]<br>
                                                                    %W - Monday-based week of the year as a decimal number [00,53]<br>
                                                                    %x - the locale’s date, such as %-m/%-d/%Y<br>
                                                                    %X - the locale’s time, such as %-I:%M:%S %p<br>
                                                                    %y - year without century as a decimal number [00,99]<br>
                                                                    %Y - year with century as a decimal number, such as 1999<br>
                                                                    %Z - time zone offset, such as -0700, -07:00, -07, or Z<br>
                                                                    %% - a literal percent sign (%)
                                                                </div>
                                                            </v-tooltip>
                                                        </template>
                                                    </v-combobox>
                                                    <v-switch color="success"
                                                              v-model="editChartConfig['layout-overrides'].xaxis.limitTicksToData"
                                                              :label="'Limit X Axis Ticks'|translate"
                                                    ></v-switch>
                                                    <v-switch color="success"
                                                              v-model="editChartConfig['layout-overrides'].xaxis.useCustomAxis"
                                                              v-if="editChartConfig['x-axis']!=='timestamp'"
                                                              :label="'X Axis Custom Range'|translate"
                                                    ></v-switch>
                                                    <v-text-field :label="'X Axis Min'" type="number" v-if="editChartConfig['x-axis']!=='timestamp'&&editChartConfig['layout-overrides'].xaxis.useCustomAxis"
                                                                  v-model.number="editChartConfig['layout-overrides'].xaxis.customAxisMin" clearable></v-text-field>
                                                    <v-text-field :label="'X Axis Max'" type="number" v-if="editChartConfig['x-axis']!=='timestamp'&&editChartConfig['layout-overrides'].xaxis.useCustomAxis"
                                                                  v-model.number="editChartConfig['layout-overrides'].xaxis.customAxisMax" clearable></v-text-field>
                                                <v-select
                                                        :items="catergorySortTypes"
                                                        :label="'X Axis Summary Sort'|translate"
                                                        v-if="hasSummarySeries"
                                                        clearable
                                                        v-model="editChartConfig['layout-overrides'].xaxis.categoryorder"
                                                    ></v-select>
                                                    <custom-view-selector
                                                        v-if="hasSummarySeries"
                                                        :label="'X Axis Equipment View Jump'|translate"
                                                        clearable
                                                        v-model="editChartConfig['layout-overrides'].jumpToCVOnX"
                                                    ></custom-view-selector>
                                                <v-text-field clearable v-model="editChartConfig['layout-overrides'].yaxis.title" type="text" :label="'Y Axis Label'|translate"></v-text-field>
                                                    <v-combobox
                                                        :items="tickFormatOptions"
                                                        clearable
                                                        :label="'Y Axis Format'|translate"
                                                        v-model="editChartConfig['layout-overrides'].yaxis.tickformat"
                                                    >
                                                        <template v-slot:append>
                                                            <v-tooltip bottom>
                                                                <template v-slot:activator="{ on }" >
                                                                    <v-icon
                                                                        v-on="on"
                                                                    >
                                                                        fa-info-circle
                                                                    </v-icon>
                                                                </template>
                                                                <div>
                                                                    %a - abbreviated weekday name.<br>
                                                                    %A - full weekday name<br>
                                                                    %b - abbreviated month name<br>
                                                                    %B - full month name<br>
                                                                    %c - the locale’s date and time, such as %x, %X<br>
                                                                    %d - zero-padded day of the month as a decimal number [01,31]<br>
                                                                    %e - space-padded day of the month as a decimal number [ 1,31]; equivalent to %_d<br>
                                                                    %f - microseconds as a decimal number [000000, 999999]<br>
                                                                    %g - ISO 8601 week-based year without century as a decimal number [00,99]<br>
                                                                    %G - ISO 8601 week-based year with century as a decimal number<br>
                                                                    %H - hour (24-hour clock) as a decimal number [00,23]<br>
                                                                    %I - hour (12-hour clock) as a decimal number [01,12]<br>
                                                                    %j - day of the year as a decimal number [001,366]<br>
                                                                    %m - month as a decimal number [01,12]<br>
                                                                    %M - minute as a decimal number [00,59]<br>
                                                                    %L - milliseconds as a decimal number [000, 999]<br>
                                                                    %p - either AM or PM<br>
                                                                    %q - quarter of the year as a decimal number [1,4]<br>
                                                                    %Q - milliseconds since UNIX epoch<br>
                                                                    %s - seconds since UNIX epoch<br>
                                                                    %S - second as a decimal number [00,61]<br>
                                                                    %u - Monday-based (ISO 8601) weekday as a decimal number [1,7]<br>
                                                                    %U - Sunday-based week of the year as a decimal number [00,53]<br>
                                                                    %V - ISO 8601 week of the year as a decimal number [01, 53]<br>
                                                                    %w - Sunday-based weekday as a decimal number [0,6]<br>
                                                                    %W - Monday-based week of the year as a decimal number [00,53]<br>
                                                                    %x - the locale’s date, such as %-m/%-d/%Y<br>
                                                                    %X - the locale’s time, such as %-I:%M:%S %p<br>
                                                                    %y - year without century as a decimal number [00,99]<br>
                                                                    %Y - year with century as a decimal number, such as 1999<br>
                                                                    %Z - time zone offset, such as -0700, -07:00, -07, or Z<br>
                                                                    %% - a literal percent sign (%)
                                                                </div>
                                                            </v-tooltip>
                                                        </template>
                                                    </v-combobox>
                                                    <v-switch color="success"
                                                              v-model="editChartConfig['layout-overrides'].yaxis.useCustomAxis"
                                                              :label="'Y Axis Custom Range'|translate"
                                                    ></v-switch>
                                                    <v-text-field :label="'Y Axis Min'" type="number" v-if="editChartConfig['layout-overrides'].yaxis.useCustomAxis"
                                                                  v-model.number="editChartConfig['layout-overrides'].yaxis.customAxisMin" clearable></v-text-field>
                                                    <v-text-field :label="'Y Axis Max'" type="number" v-if="editChartConfig['layout-overrides'].yaxis.useCustomAxis"
                                                                  v-model.number="editChartConfig['layout-overrides'].yaxis.customAxisMax" clearable></v-text-field>

                                                    <v-select
                                                        :items="catergorySortTypes"
                                                        :label="'Y Axis Summary Sort'|translate"
                                                        v-if="hasSummarySeries"
                                                        clearable
                                                        v-model="editChartConfig['layout-overrides'].yaxis.categoryorder"
                                                    ></v-select>
                                                    <custom-view-selector
                                                        v-if="hasSummarySeries"
                                                        :label="'Y Axis Equipment View Jump'|translate"
                                                        clearable
                                                        v-model="editChartConfig['layout-overrides'].jumpToCVOnY"
                                                    ></custom-view-selector>
                                                    <v-switch color="success"
                                                              v-model="hasSecondaryAxis"
                                                              :label="'Secondary Y Axis'|translate"
                                                              @change="handleSAChange"
                                                    ></v-switch>
                                                <v-text-field clearable v-if="editChartConfig['layout-overrides'].yaxis2" v-model="editChartConfig['layout-overrides'].yaxis2.title" type="text" :label="'Secondary Y Axis Label'|translate"></v-text-field>
                                                    <v-switch color="success"
                                                              v-model="editChartConfig['layout-overrides'].yaxis2.useCustomAxis"
                                                              v-if="editChartConfig['layout-overrides'].yaxis2"
                                                              :label="'Secondary Y Axis Custom Range'|translate"
                                                    ></v-switch>
                                                    <v-text-field :label="'Secondary Y Axis Min'" type="number" v-if="editChartConfig['layout-overrides'].yaxis2&&editChartConfig['layout-overrides'].yaxis2.useCustomAxis"
                                                                  v-model.number="editChartConfig['layout-overrides'].yaxis2.customAxisMin" clearable></v-text-field>
                                                    <v-text-field :label="'Secondary Y Axis Max'" type="number" v-if="editChartConfig['layout-overrides'].yaxis2&&editChartConfig['layout-overrides'].yaxis2.useCustomAxis"
                                                                  v-model.number="editChartConfig['layout-overrides'].yaxis2.customAxisMax" clearable></v-text-field>
                                                <v-select
                                                        :items="axisPotentialValues"
                                                        :label="'Color Axis Field'|translate"
                                                        clearable
                                                        v-model="editChartConfig['color-axis']"
                                                ></v-select>
                                                <v-autocomplete
                                                        :items="colorscales"
                                                        :label="'Color Axis Scale'|translate"
                                                        v-if="editChartConfig['color-axis']"
                                                        v-model="editChartConfig['color-axis-scale']"
                                                        clearable
                                                ></v-autocomplete>
                                                  <v-switch color="success"
                                                            v-model="editChartConfig['layout-overrides'].colorscaleUseCustomAxis"
                                                            v-if="editChartConfig['color-axis']"
                                                            :label="'Color Axis Custom Range'|translate"
                                                  ></v-switch>
                                                  <v-text-field :label="'Color Axis Min'" type="number" v-if="editChartConfig['color-axis']&&editChartConfig['layout-overrides'].colorscaleUseCustomAxis"
                                                                v-model.number="editChartConfig['layout-overrides'].colorscaleAxisMin" clearable></v-text-field>
                                                  <v-text-field :label="'Color Axis Max'" type="number" v-if="editChartConfig['color-axis']&&editChartConfig['layout-overrides'].colorscaleUseCustomAxis"
                                                                v-model.number="editChartConfig['layout-overrides'].colorscaleAxisMax" clearable></v-text-field>
                                                <v-text-field
                                                        :label="'Color Axis Label'|translate"
                                                        type="text"
                                                        v-if="editChartConfig['color-axis']"
                                                        v-model="editChartConfig['color-axis-title']"
                                                        clearable
                                                ></v-text-field>
                                                    <v-select
                                                        :items="axisPotentialValues"
                                                        :label="'Marker Size Field'|translate"
                                                        clearable
                                                        v-model="editChartConfig['marker-size-axis']"
                                                    ></v-select>
                                                <v-select v-if="has3dSeries"
                                                        :items="axisPotentialValues"
                                                        :label="'3D Mode Y Axis Field'|translate"
                                                        clearable
                                                        v-model="editChartConfig['y-axis']"
                                                ></v-select>
                                                <v-text-field clearable v-model="editChartConfig['layout-overrides'].zaxis.title" type="text" :label="'Z Axis Label'|translate" v-if="editChartConfig['y-axis']"></v-text-field>
                                                    <v-switch color="success"
                                                              v-model="editChartConfig['layout-overrides'].zaxis.useCustomAxis"
                                                              v-if="editChartConfig['y-axis']"
                                                              :label="'Z Axis Custom Range'|translate"
                                                    ></v-switch>
                                                    <v-text-field :label="'Z Axis Min'" type="number" v-if="editChartConfig['y-axis']&&editChartConfig['layout-overrides'].zaxis.useCustomAxis"
                                                                  v-model.number="editChartConfig['layout-overrides'].zaxis.customAxisMin" clearable></v-text-field>
                                                    <v-text-field :label="'Z Axis Max'" type="number" v-if="editChartConfig['y-axis']&&editChartConfig['layout-overrides'].zaxis.useCustomAxis"
                                                                  v-model.number="editChartConfig['layout-overrides'].zaxis.customAxisMax" clearable></v-text-field>
                                            </v-card-text>
                                            </v-card>
                                        </v-expansion-panel-content>
                                        <v-expansion-panel-content class="accent">
                                            <template v-slot:header>
                                                <v-card-title class="accent white--text subheading">
                                                    {{'Annotations'|translate}}
                                                </v-card-title>
                                            </template>
                                            <v-card>
                                                <v-card-text>
                                                    <v-layout row v-for="(annotation, index) in editChartConfig['layout-overrides'].annotations" class="mb-2">
                                                        <v-flex xs2 ><div class="text-truncate mr-2">{{annotation.x}}</div></v-flex>
                                                        <v-flex xs2 ><div class="text-truncate mr-2">{{annotation.y}}</div></v-flex>
                                                        <v-flex xs7><div class="text-truncate mr-2">{{annotation.text}}</div></v-flex>
                                                        <v-flex xs1><v-icon small @click="editChartConfig['layout-overrides'].annotations.splice(index, 1)">fa-trash</v-icon></v-flex>


                                                    </v-layout>
                                                    <v-layout row>
                                                        <v-flex xs2>
                                                            <v-text-field :label="'X'" type="number" class="mr-2" v-if="editChartConfig['x-axis']!=='timestamp'"
                                                                                  v-model.number="annotationX"></v-text-field>
                                                            <v-text-field :label="'X'" class="mr-2" v-if="editChartConfig['x-axis']==='timestamp'"
                                                                                  v-model="annotationX"></v-text-field>
                                                            </v-flex>
                                                        <v-flex xs2><v-text-field :label="'Y'" type="number" class="mr-2"
                                                                                  v-model.number="annotationY"></v-text-field></v-flex>
                                                        <v-text-field :label="'Text'"
                                                                      v-model="annotationText"></v-text-field>
                                                        <v-btn color="primary" :disabled="!annotationText||annotationText==''" @click="addAnnotation">{{'Add'|translate}}</v-btn>
                                                    </v-layout>
                                                </v-card-text>
                                            </v-card>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>

                                </v-card-text>
                            </v-card>
                        </v-flex>
                    </v-layout>

                </v-card-text>
                <v-card-actions v-if="callback" class="accent" 
                    style="width:100%; position:fixed; bottom: 0; left:0; z-index:3" >
                    <v-layout row>
                        <v-btn   @click="close">{{'Close'|translate}}</v-btn>
                        <v-spacer></v-spacer>
                        <v-btn color="primary"  @click="save">{{'Save'|translate}}</v-btn>
                    </v-layout>
                </v-card-actions>
            </v-card>
        </v-flex>


    </v-layout>
</template>

<script>
    import moment from 'moment'
    import Data3Chart from "../components/Data3Chart";
    import DateRangeSelector from "../components/DateRangeSelector";
    import {sortFloors} from '@/helper'
    import draggable from 'vuedraggable'
    import SensorSelector from "../components/SensorSelector";
    import PointsDraggable from "@/components/multiplots/PointsDraggable";
    import layoutPresets from '../config/presets/layouts.js'
    import CustomViewSelector from "@/components/CustomViewSelector";
    import editor from 'vue2-ace-editor'

    export default {
        name: 'ChartBuilder',
        components:{Data3Chart,DateRangeSelector,draggable,SensorSelector,PointsDraggable, CustomViewSelector,editor},
        props: {
            defaultRange: {type: Object, default: null},
            parameters: {type: Object, default: null},
            initialValue: {type: Object, default: null},
            callback: {type: Function,default:null},
            headlessMode: {type: Boolean,default:false},
            equipmentRelationships: {type: Array,default:()=>{return[]}},
        },
        computed: {
            availableParameters(){
                return this.parameters ? Object.keys(this.parameters) : []
            },
            has3dSeries(){
                return this.editChartConfig['data-payload']&&this.editChartConfig['data-payload'].filter(x=>x.seriesOverrides.type==="scatter3d"||x.seriesOverrides.type==="mesh3d").length>0
            },
            hasSummarySeries(){
                return this.editChartConfig['data-payload']&&this.editChartConfig['data-payload'].filter(x=>x.seriesOverrides.type==="bar summary"||x.seriesOverrides.type==="scatter summary"||x.seriesOverrides.type==="heatmap"||x.seriesOverrides.type==="histogram2d").length>0
            },
            lastLayoutOverrides(){
                return this.editChartConfig['data-payload']&&this.editChartConfig['data-payload'].length>0 ? JSON.parse(JSON.stringify(this.editChartConfig['data-payload'][this.editChartConfig['data-payload'].length-1].seriesOverrides))  : {
                    type:this.headlessMode ? 'table' : 'scatter',
                    opacity:1,
                    xbins: {
                        size: 1
                    },
                    ybins: {
                        size: 1
                    }
                }
            },
            axisPotentialValues(){
                let values=["timestamp"]
                for (let payload of this.editChartConfig['data-payload']) {
                    if (payload.filters.sensor_name) {
                        values.push(payload.filters.sensor_name)
                    }
                    if (payload.pipeline) {
                        for (let pipelineStage of payload.pipeline) {
                            if (pipelineStage.name && pipelineStage.name !== "") {
                                values.push(pipelineStage.name.indexOf(" - ")===-1 ? pipelineStage.name : pipelineStage.name.split("- ")[1])
                            } else if (pipelineStage.series&&Array.isArray(pipelineStage.series)&&pipelineStage.series.length>0){
                                values.push(...pipelineStage.series.map(x=>x.indexOf(" - ")===-1 ? x : x.split("- ")[1]))
                            }
                        }
                    }
                }
                return [...new Set(values)]
            },
            scopedCombinations(){
                if(!this.editChartConfig||!this.combinations||!this.editChartConfig["data-payload"]||this.editChartConfig["data-payload"].length===0){
                    return []
                }
                let scopedCombos=[]
                for (let payload of this.editChartConfig["data-payload"]){
                    let scopedCombo={}
                    for (let filterName of this.filterNames){
                        if(Object.keys(payload.filters).length===0||(Object.keys(payload.filters).length===1&&payload.filters[filterName])){
                            if(filterName==="equipment_tags"){
                              scopedCombo[filterName]=[...new Set([].concat.apply([], this.combinations.map(x=>x[filterName])))].sort()
                            } else {
                              scopedCombo[filterName]=[...new Set(this.combinations.map(x=>x[filterName]))].sort()
                            }
                        } else {
                          let otherFilters = this.filterNames.filter(x => x !== filterName && payload.filters[x])
                          if (filterName === "equipment_tags") {
                            scopedCombo[filterName]=[...new Set([].concat.apply([], this.combinations.filter((x) => {
                              for (let otherFilter of otherFilters) {
                                if (otherFilter === "equipment_tags") {
                                  if (!payload.filters[otherFilter].every(v => x[otherFilter].includes(v))) {
                                    return false
                                  }
                                } else {
                                  if (x[otherFilter] !== payload.filters[otherFilter]) {
                                    return false
                                  }
                                }

                              }
                              return true
                            }).map(x=>x[filterName])))].sort()
                          } else {
                            scopedCombo[filterName] = [...new Set(this.combinations.filter((x) => {
                              for (let otherFilter of otherFilters) {
                                if (otherFilter === "equipment_tags") {
                                  if (!payload.filters[otherFilter].every(v => x[otherFilter].includes(v))) {
                                    return false
                                  }
                                } else {
                                  if (x[otherFilter] !== payload.filters[otherFilter]) {
                                    return false
                                  }
                                }

                              }
                              return true
                            }).map(x => x[filterName]))].sort()
                          }

                        }
                        if(filterName!=="equipment_tags"&&payload.filters&&payload.filters[filterName]&&(scopedCombo[filterName].length===0||scopedCombo[filterName].indexOf(payload.filters[filterName])===-1)){
                            scopedCombo[filterName].push(payload.filters[filterName])
                        }

                    }
                    if (scopedCombo.floor){
                        scopedCombo.floor=sortFloors(scopedCombo.floor.filter(x=>x&&x!==""))
                    }
                    scopedCombos.push(scopedCombo)
                }
                return scopedCombos
            }
        },
        data(){
            return{
            range: {start: moment().subtract(30, "days").format('YYYY-MM-DD'), end: moment().format('YYYY-MM-DD')},
            centralizedAgg:{"type": "agg", "agg": "H", "agg_op": "sum","divide_by_sf":true},
            showCentralizedAgg:false,
            hasSecondaryAxis:false,
            loading:true,
            showPointsTree:false,
            annotationX: null,
            addJsonDialog:false ,
            jsonImport:"",
            annotationY: null,
            annotationText: null,
            annotationAx: 0,
            annotationAy: -40,
            debugMode:false,
            newColor:null,
            panel:0,
            combinations:[],
            quickLayouts:layoutPresets,
            relativeRangeOptions: ["30 days","current week","current month","current year","last week","last month","last year","yesterday", "today"],
            tickFormatOptions:['%x', '%X', '%H', '%A', '%B', '%Y'],
            hovermode:[
                {
                    text:this.$options.filters.translate("Compare X"),
                    value:"x"
                }, {
                    text:this.$options.filters.translate("Closest to pointer"),
                    value:"closest"
                }
            ],
            offsetTypes:["days","weeks","months","years"],
            catergorySortTypes:["category ascending","category descending","total ascending","total descending"],
            reloadChart:false,
            filterNames:["sensor_name","equipment_type","equipment_name","floor","equipment_tags"],
            yAxisChoices: [
                {
                    text:this.$options.filters.translate("Primary"),
                    value:"y"
                }, {
                    text:this.$options.filters.translate("Secondary"),
                    value:"y2"
                }
            ],
            aggFreq: [
                {
                    text:this.$options.filters.translate("hour"),
                    value:"H"
                },{
                    text:this.$options.filters.translate("day"),
                    value:"D"
                },{
                    text:this.$options.filters.translate("week"),
                    value:"W"
                },{
                    text:this.$options.filters.translate("month start"),
                    value:"MS"
                },{
                    text:this.$options.filters.translate("month end"),
                    value:"M"
                },{
                    text:this.$options.filters.translate("year start"),
                    value:"YS"
                },{
                    text:this.$options.filters.translate("year end"),
                    value:"Y"
                },{
                    text:this.$options.filters.translate("all"),
                    value:"all"
                },{
                    text:this.$options.filters.translate("custom month"),
                    value:"custom_month"
                }
            ],
            aggOpp: ["sum","mean","count","min","max"],
            filterOpp: [
                {
                    text:"=",
                    value:"eq"
                },
                {
                    text:"!=",
                    value:"neq"
                },
                {
                    text:">",
                    value:"gt"
                },
                {
                    text:">=",
                    value:"ge"
                },
                {
                    text:"<",
                    value:"lt"
                },
                {
                    text:"<=",
                    value:"le"
                },
            ],
            stackGroups: ["One","Two","Three"],
            colorscales: ["Blackbody",
                "Bluered",
                "Blues",
                "Earth",
                "Electric",
                "Greens",
                "Greys",
                "Hot",
                "Jet",
                "Picnic",
                "Portland",
                "Rainbow",
                "RdBu",
                "Reds",
                "Viridis",
                "YlGnBu",
                "YlOrRd"],
            seriesTypes:[
                "scatter",
                "bar",
                "heatmap",
                "pie",
                "scatter3d",
                "mesh3d",
                "histogram",
                "histogram2d",
                "indicator",
                "box",
                "violin",
                "table",
                "bar summary",
                "scatter summary",
                "parallel coordinates",
                "scatterpolar",
                "barpolar",
            ],
                aggTypicalTypes:[
                    "pie",
                    "bar summary",
                    "scatter summary",
                ],
            scatterModes:[
                "lines",
                "markers",
                "lines+markers",
                "none",
            ],
            indicatorModes:[
                "number",
                "gauge+number",
            ],
            barModes:[
                "group",
                "stack",
                "overlay",
            ],
                histnorms:[
                    "percent", "probability", "density", "probability density"
                ],
            legendModes:[
                "top",
                "bottom",
                "right",
                "left",
            ],
            polarFillModes:["none","toself","tonext"],
            fillModes:[
                "tozeroy",
                "tonexty",
            ],
            defaultChartConfig:{
                    'layout-overrides': {
                        title:"",
                        colorway : [  '#1f77b4',  // muted blue
                            '#ff7f0e',  // safety orange
                            '#2ca02c',  // cooked asparagus green
                            '#d62728',  // brick red
                            '#9467bd',  // muted purple
                            '#8c564b',  // chestnut brown
                            '#e377c2',  // raspberry yogurt pink
                            '#7f7f7f',  // middle gray
                            '#bcbd22',  // curry yellow-green
                            '#17becf'],
                        showlegend:true,
                        height:300,
                        hovermode:"x",
                        margin:{
                            l: 50,
                            r: 50,
                            t: 50,
                            pad: 1
                        },
                        xaxis: {
                            title: ""
                        },
                        yaxis: {
                            title: ""
                        },
                        zaxis: {
                            title: null
                        },
                    },
                "x-axis":"timestamp",
                "y-axis":null,
                "independent-x":false,
                "color-axis":null,
                "marker-size-axis":null,
                "color-axis-scale":null,
                "color-axis-title":null,
                    'data-payload': [{
                        'filters': {
                        },
                        seriesOverrides:{
                            type:'scatter',
                            opacity:1,
                            xbins: {
                                size: 1
                            },
                            ybins: {
                                size: 1
                            }
                        },
                        pipeline:[],
                        offsetRange:false,
                        offsetRangeStartOnly:false,
                        offsetType:"months",
                        offsetAmount:1
                    }]
            },headlessChartConfig:{
                    'layout-overrides': {
                        title:"",
                        showlegend:false,
                        height:300,
                        margin:{
                            l: 50,
                            r: 50,
                            b: 0,
                            t: 0,
                            pad: 1
                        },
                        xaxis: {
                            title: ""
                        },
                        yaxis: {
                            title: ""
                        },
                        zaxis: {
                            title: null
                        },
                    },
                "x-axis":"timestamp",
                "y-axis":null,
                "independent-x":false,
                "color-axis":null,
                "marker-size-axis":null,
                "color-axis-scale":null,
                "color-axis-title":null,
                    'data-payload': [{
                        'filters': {
                        },
                        seriesOverrides:{
                            type:'table',
                            opacity:1,
                            xbins: {
                                size: 1
                            },
                            ybins: {
                                size: 1
                            }
                        },
                        pipeline:[],
                        offsetRange:false,
                        offsetRangeStartOnly:false,
                        offsetType:"months",
                        offsetAmount:1
                    }]
            },
            chartConfig:null,
            editChartConfig:null,
            calcOps:[
                "+",
                "-",
                "*",
                "/",
                "(",
                ")",
            ],

        }},
        methods: {
            jsonEditorInit: function () {
                require('brace/ext/language_tools')
                require('brace/mode/json')
                require('brace/theme/twilight')
            },
            applyLayoutPreset(preset){
                this.editChartConfig['layout-overrides'].barmode=null
                this.editChartConfig['layout-overrides'].hovermode="x"
                this.editChartConfig['layout-overrides'].margin={
                    l: 50,
                    r: 50,
                    t: 50,
                    pad: 1
                }
                for (let payload of this.editChartConfig['data-payload']){
                    payload.seriesOverrides=JSON.parse(JSON.stringify(preset.config.seriesOverrides))
                }
                if (preset.config['layout-overrides']){
                    let overrides=JSON.parse(JSON.stringify(preset.config['layout-overrides']))
                    for (let key in overrides){
                        this.editChartConfig['layout-overrides'][key]=overrides[key]
                    }
                }
                this.applySettings()
            },
            applyCentralizedAgg(){
                for (let payload of this.editChartConfig['data-payload']){
                    payload.pipeline=payload.pipeline.filter(x=>x.type!=="agg")
                    payload.pipeline.push(JSON.parse(JSON.stringify(this.centralizedAgg)))
                }
                this.applySettings()
            },
            clearCentralizedAgg(){
                for (let payload of this.editChartConfig['data-payload']){
                    payload.pipeline=payload.pipeline.filter(x=>x.type!=="agg")
                }
                this.applySettings()
            },
            addToFormula(pipelineStage,item){
                if(this.calcOps.indexOf(item)>-1){
                    pipelineStage.formula=pipelineStage.formula+item
                } else {
                    pipelineStage.formula=pipelineStage.formula+'df["'+item+'"]'
                }
            },
            addParamToFormula(pipelineStage,item){
                pipelineStage.formula=pipelineStage.formula+'parameters["'+item+'"]'
            },
            handleRSClick(payload,series){
                let newPermitted=this.getCalcStrings(payload,99,true).filter(x=>x!==series)
                if(payload.pipeline&&payload.pipeline.length>0&&payload.pipeline[payload.pipeline.length-1].type==="select_series"){
                    payload.pipeline[payload.pipeline.length-1].series=newPermitted
                } else {
                    payload.pipeline.push({
                        type:'select_series',
                        series:newPermitted
                    })
                }
            },
            getPossibleEquipRelTypes(name){
                if(name&&name!==""){
                    return this.equipmentRelationships.filter(x=>x.equip1===name).map(x=>x.type)
                } else {
                    return []
                }
            },
            getPossibleEquipRelCombos(name,ref_type){
                if(name&&name!==""&&ref_type&&ref_type!==""){
                    let names = this.equipmentRelationships.filter(x=>x.equip1===name&&x.type===ref_type).map(x=>x.equip2)
                    let possibilities = this.combinations.filter(x=>names.includes(x.equipment_name))
                    return {
                        equipment_type:possibilities.map(x=>x.equipment_type),
                        sensor_name: possibilities.map(x=>x.sensor_name),
                    }
                }
                return {
                    equipment_type:[],
                    sensor_name:[],
                }
            },
            getCalcStrings(payload,index,skipPredef=false){
                let predefined=[]
                if(!skipPredef){
                    predefined=[...this.calcOps]
                }
                if(payload.filters&&(payload.filters.sensor_name||payload.filters.equipment_name)){
                    let possibilities=this.combinations.filter(x=>{
                        for (let key in payload.filters){
                            if (key === "equipment_tags") {
                                if (!payload.filters[key].every(v => x[key].includes(v))) {
                                    return false
                                }
                            } else {
                                if(payload.filters[key]&&x[key]!==payload.filters[key]){
                                    return false
                                }
                            }
                        }
                        return true
                    })
                    possibilities=possibilities.map(x=>x.equipment_name+" - "+x.sensor_name)
                    if(payload.pipeline) {
                        for (let pipelineStageIndex in payload.pipeline) {
                           if(pipelineStageIndex<index){
                               let pipelineStage = payload.pipeline[pipelineStageIndex]
                               if (pipelineStage.type === "insert_series"||pipelineStage.type === "insert_calendar") {
                                   possibilities.push(pipelineStage.name)
                               } else if (pipelineStage.type === "agg_h") {
                                   possibilities = [pipelineStage.name]
                               } else if (pipelineStage.type==='select_series') {
                                   possibilities = [...pipelineStage.series]
                               } else if (pipelineStage.type==='calculate') {
                                   if(pipelineStage.remove_others){
                                       possibilities = [pipelineStage.name]
                                   } else {
                                       possibilities.push(pipelineStage.name)
                                   }
                               } else if (pipelineStage.type==='insert_series_by_ref'){
                                   if(payload.filters.equipment_name&&payload.filters.equipment_name!==""&&pipelineStage.ref_type&&pipelineStage.ref_type!==""&&pipelineStage.sensor_name&&pipelineStage.sensor_name!==""){
                                       let names = this.equipmentRelationships.filter(x=>x.equip1===payload.filters.equipment_name&&x.type===pipelineStage.ref_type).map(x=>x.equip2)
                                       let insertedCombos = this.combinations.filter(x=>names.includes(x.equipment_name)&&x.sensor_name===pipelineStage.sensor_name)
                                       if(pipelineStage.equipment_type&&pipelineStage.equipment_type!==""){
                                           insertedCombos=insertedCombos.filter(x=>x.equipment_type===pipelineStage.equipment_type)
                                       }
                                       let insertedNames=insertedCombos.map(x=>x.equipment_name+" - "+x.sensor_name)
                                       if(pipelineStage.remove_others){
                                           possibilities = [...insertedNames]
                                       } else {
                                           possibilities.push(...insertedNames)
                                       }
                                   }

                               }
                           } else {
                               break
                           }
                        }
                    }
                    return [...possibilities,...predefined]
                }
                return predefined
            },
            arrmove(arr, fromIndex, toIndex) {
              let element = arr[fromIndex];
              arr.splice(fromIndex, 1);
              arr.splice(toIndex, 0, element);
            },
            isPayloadAnAxis(payload){
                let values=[]
                if(!payload.filters.sensor_name){
                    return false
                }
                values.push(payload.filters.sensor_name)
                if(payload.pipeline){
                    for (let pipelineStage of payload.pipeline){
                        if(pipelineStage.type==="insert_series"){
                            return false
                        }
                        if(pipelineStage.name&&pipelineStage.name!==""){
                            values.push(pipelineStage.name)
                        }
                    }
                }
                if (values.includes(this.editChartConfig['x-axis'])||
                    (this.editChartConfig['y-axis']&&this.editChartConfig['y-axis']!==""&&values.includes(this.editChartConfig['y-axis']))||
                    (this.editChartConfig['color-axis']&&this.editChartConfig['color-axis']!==""&&values.includes(this.editChartConfig['color-axis']))||
                    (this.editChartConfig['marker-size-axis']&&this.editChartConfig['marker-size-axis']!==""&&values.includes(this.editChartConfig['marker-size-axis']))){
                    return true
                }
                return false

            },
            handleSAChange(value){
                if(value&&!this.editChartConfig['layout-overrides'].yaxis2){
                    this.editChartConfig['layout-overrides'].yaxis2={
                        title: "",
                        overlaying: 'y',
                        showgrid:false,
                        side: 'right'
                    }
                    for (let payload of this.editChartConfig['data-payload']){
                        payload.seriesOverrides.yaxis="y"
                    }
                } else {
                    delete(this.editChartConfig['layout-overrides'].yaxis2)

                    for (let payload of this.editChartConfig['data-payload']){
                        delete(payload.seriesOverrides.yaxis)
                    }
                }
            },
            addQuery(){
                let newOverrides=JSON.parse(JSON.stringify(this.lastLayoutOverrides))
                this.editChartConfig['data-payload'].push({
                    filters: {
                    },
                    seriesOverrides:newOverrides,
                    pipeline:[],
                    offsetRange:false,
                    offsetRangeStartOnly:false,
                    offsetType:"months",
                    offsetAmount:1

                })
            },
            addAgg(index){
                this.editChartConfig['data-payload'][index].pipeline.push(
                    {"type": "agg", "agg": "H", "agg_op": "sum","divide_by_sf":true}
                )
            },addCovertToEnum(index){
                this.editChartConfig['data-payload'][index].pipeline.push(
                    {"type": "convert_to_enum"}
                )
            },addCalc(index){
                this.editChartConfig['data-payload'][index].pipeline.push(
                    {"type": "calculate", "name": "Calculated", "formula": "","remove_others":false}
                )
            },addCalcGlobal(index){
                this.editChartConfig['data-payload'][index].pipeline.push(
                    {"type": "calculate_global", "formula": "df"}
                )
            },addNotes(index){
                this.editChartConfig['data-payload'][index].pipeline.push(
                    {"type": "notes", "text": ""}
                )
            },addFilter(index){
                this.editChartConfig['data-payload'][index].pipeline.push(
                    {
                        "type": "filter",
                        "filter_op": "gt",
                        "filter_by": "* - "+this.editChartConfig['data-payload'][index].filters.sensor_name,
                        "filter_value": 0,
                    }
                )
            },addSeriesSelect(index){
                this.editChartConfig['data-payload'][index].pipeline.push(
                    {
                        "type": "select_series",
                        "series": [],
                        "newSeries": null
                    }
                )
            },addSeriesInsert(index){
                this.editChartConfig['data-payload'][index].pipeline.push(
                    {
                        "type": "insert_series",
                        "name":null,
                    }
                )
            },addSeriesCalendar(index){
                this.editChartConfig['data-payload'][index].pipeline.push(
                    {
                        "type": "insert_calendar",
                        "name":null,
                    }
                )
            },
            addSeriesInsertionByRef(index){
                this.editChartConfig['data-payload'][index].pipeline.push(
                    {
                        "type": "insert_series_by_ref",
                        "ref_type":null,
                        "equipment_type":null,
                        "sensor_name":null,
                        "remove_others":true
                    }
                )
            },
            addAggH(index){
                this.editChartConfig['data-payload'][index].pipeline.push(
                    {"type": "agg_h", "agg_op": "sum","name":"Sum" }
                )
            },copyQuery(query){
                this.editChartConfig['data-payload'].push(JSON.parse(JSON.stringify(query)))
            },deleteQuery(index){
                this.editChartConfig['data-payload'].splice(index, 1)
            },
            deleteFromPipeline(index,subindex){
                this.editChartConfig['data-payload'][index].pipeline.splice(subindex,1)
            },
            applySettings(){
                let me=this
                this.reloadChart=true
                let newConfig=JSON.parse(JSON.stringify(this.editChartConfig))
                if (this.debugMode){
                    for (let payload of newConfig['data-payload']){
                        payload.seriesOverrides={"type": "table", "opacity": 1, "xbins": {"size": 1},"ybins": {"size": 1}}
                    }
                }
                this.chartConfig=newConfig
                setTimeout(function(){me.reloadChart=false},100)
            },
            save(){
                this.callback(JSON.parse(JSON.stringify(this.editChartConfig)))
                this.$emit('close')
            },
            copyToCP() {
                let me = this
                this.$copyText(JSON.stringify(this.editChartConfig)).then(function (e) {
                    me.$store.dispatch('callSnackbar', {text: me.$options.filters.translate('Query copied to clipboard')})
                }, function (e) {
                    console.log(e)
                })
            },
            importFromJson(){
                let newQuery=JSON.parse(this.jsonImport)
                if (this.headlessMode){
                    for (let payload of newQuery['data-payload']){
                        payload.seriesOverrides.type='table'
                    }
                }
                this.editChartConfig=newQuery
                if(this.editChartConfig['layout-overrides'].yaxis2){
                    this.hasSecondaryAxis=true
                }
                this.addJsonDialog=false
                this.jsonImport=""
            },
            close() {
                this.$emit('close')
            },
            handleChartClick(data){
                if(data.points&&data.points[0]&&data.points[0].x){
                    this.annotationX=data.points[0].x
                    this.annotationY=data.points[0].y
                }
            },
            addAnnotation(){
                if (!this.editChartConfig['layout-overrides'].annotations){
                    this.editChartConfig['layout-overrides'].annotations=[]
                }
                this.editChartConfig['layout-overrides'].annotations.push(
                    {
                        xref: 'x',
                        yref: 'y',
                        x: this.annotationX,
                        y: this.annotationY,
                        text: this.annotationText,
                        showarrow: true,
                        ax: this.annotationAx,
                        ay: this.annotationAy,
                        arrowcolor: "#FFFFFF"
                    }
                )
                this.annotationText=null
                this.annotationX=null
                this.annotationY=null
            }
        },
        mounted () {
            let combinations=this.$store.state.pointsListStore.pointsList.points_list.map(sensor=>{return{
                sensor_name:sensor.sensor_name,
                equipment_name:sensor.equipment_name,
                equipment_type:this.$store.state.pointsListStore.pointsList.equipment_details[sensor.equipment_name].equipment_type,
                equipment_tags:this.$store.state.pointsListStore.pointsList.equipment_details[sensor.equipment_name].equipment_tags ? this.$store.state.pointsListStore.pointsList.equipment_details[sensor.equipment_name].equipment_tags : [],
                floor:this.$store.state.pointsListStore.pointsList.equipment_details[sensor.equipment_name].floor,
            }})
            this.combinations=JSON.parse(JSON.stringify(combinations))
            this.loading=false


        },
        beforeMount() {
            if (this.headlessMode){
                this.defaultChartConfig=JSON.parse(JSON.stringify(this.headlessChartConfig))
            }
            if(this.initialValue){
                this.defaultChartConfig=JSON.parse(JSON.stringify(this.initialValue))
            }
            this.chartConfig=JSON.parse(JSON.stringify(this.defaultChartConfig))
            this.editChartConfig=JSON.parse(JSON.stringify(this.defaultChartConfig))
            if(this.editChartConfig['layout-overrides'].yaxis2){
                this.hasSecondaryAxis=true
            }
            let maxDate=this.$store.state.pointsListStore.pointsList.data_max_date;
            if(this.defaultRange){
                this.range=this.defaultRange
            }else if(maxDate){
                this.range={start:moment(maxDate).subtract(30, "days").format('YYYY-MM-DD'),end:moment(maxDate).format('YYYY-MM-DD')}
            }
        }

    }
</script>